import React, { useState, useEffect, useRef, useSearchParams } from "react";
import { useHistory } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";
import MyMap from "../components/MyMap";
import SlidingMenu from "../components/slidingMenu";
import { getLandingInfo } from "../api/landing";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { set } from "lodash-es";
import { Route } from "react-router-dom/cjs/react-router-dom.min";

const Landing = (prop) => {
  const { texts, langHandler, globalState } = prop;
  const history = useHistory();
  const [activeBtn, setActiveBtn] = useState("");
  const isMobile = useMediaQuery("(max-width: 768px)");
  const sectionsData = [
    {
      bgColor: "linear-gradient(97deg, #3a31ea -14%, #d01657 100%)",
      color: "#e08b14",
      iconGradiant: "#e08b14",
      id: 0,
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37"
          height="43"
          viewBox="0 0 37 43"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <g stroke="#FFF" stroke-width="1.187">
              <g>
                <path
                  d="M35.358.102L.358.102.358 41.102 29.765 41.102 29.765 12.804 35.358 12.804zM33.358 41.102L35.358 41.102 35.358 31.102 33.358 31.102"
                  transform="translate(-930 -759) translate(930.908 760)"
                />
                <path
                  d="M33.358 27.102L35.358 27.102 35.358 17.102 33.358 17.102M4.358 38.102V4.148h17.964v-.046h4.036v33.954h-.291v.046H4.358zm4.037-4.154h13.926V8.302H8.395v25.646z"
                  transform="translate(-930 -759) translate(930.908 760)"
                />
                <path
                  d="M22.358 8.137v6.29l-5.086-6.29h5.086zm-5.115 25.93h5.086v-6.291l-5.086 6.29zM13.472 8.101l-5.086 6.29v-6.29h5.086zm-.029 26H8.358v-6.29l5.085 6.29zM14.857 11.102L20.358 20.602 14.857 30.102 9.358 20.602z"
                  transform="translate(-930 -759) translate(930.908 760)"
                />
              </g>
            </g>
          </g>
        </svg>
      ),
      img: "./static/img/carpet-mobile.png",
      boldText: texts.landingText,
      lightText: "",
    },
    {
      title: texts.encyclopedia,
      name: "encyclopedia",
      id: 2,
      bgColor: "linear-gradient(97deg, #3a31ea -14%, #d01657 100%)",
      color: "#e08b14",
      iconGradiant: "#e08b14",
      buttons: [
        {
          title: texts.hande_made,
          color: "#e08b14",
          link: "https://shop.ghalichin.com/wiki/#tab_فرش-دستباف",
          svg: (
            <svg
              width="48"
              height="48"
              color="#e08b14"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="M15.435 12c1.188 0 2.236.607 2.854 1.526h13.938c.21 0 .381.171.381.382v.763h.834a1.143 1.143 0 0 1 1.074-.763c.632 0 1.145.514 1.145 1.145s-.513 1.145-1.145 1.145c-.496 0-.916-.32-1.074-.764h-.834v3.054h.834a1.143 1.143 0 0 1 1.074-.764c.632 0 1.145.514 1.145 1.145s-.513 1.145-1.145 1.145c-.496 0-.916-.32-1.074-.763h-.834v3.053h.834a1.143 1.143 0 0 1 1.074-.763c.632 0 1.145.513 1.145 1.145a1.143 1.143 0 0 1-2.22.382h-.833v3.052h.834a1.143 1.143 0 0 1 1.074-.763c.632 0 1.145.514 1.145 1.145s-.513 1.145-1.145 1.145c-.496 0-.916-.32-1.074-.763h-.834v3.053h.834a1.143 1.143 0 0 1 1.074-.764c.632 0 1.145.514 1.145 1.145s-.513 1.145-1.145 1.145c-.496 0-.916-.32-1.074-.763h-.834v3.053h.834a1.143 1.143 0 0 1 1.074-.763c.632 0 1.145.513 1.145 1.145a1.143 1.143 0 0 1-2.22.382h-.833v.762c0 .211-.17.382-.381.382H15.435A3.439 3.439 0 0 1 12 32.226V15.434A3.439 3.439 0 0 1 15.435 12zm0 17.555a2.674 2.674 0 0 0-2.672 2.671 2.674 2.674 0 0 0 2.672 2.672 2.674 2.674 0 0 0 2.671-2.672 2.674 2.674 0 0 0-2.671-2.671zm16.41-15.265H18.669c.128.358.2.743.2 1.144v.382h11.068c.21 0 .381.171.381.382V32.99c0 .21-.17.381-.381.381H18.669a3.445 3.445 0 0 1-1.08 1.527h14.256V14.29zm2.671 19.463a.382.382 0 1 0 .002.764.382.382 0 0 0-.002-.764zm-19.036-3.66a2.09 2.09 0 0 1 2.087 2.088 2.09 2.09 0 0 1-2.087 2.088 2.09 2.09 0 0 1-2.088-2.088 2.09 2.09 0 0 1 2.088-2.087zm0 .836c-.691 0-1.253.562-1.253 1.252 0 .691.562 1.253 1.253 1.253.69 0 1.252-.562 1.252-1.253 0-.69-.562-1.252-1.252-1.252zm14.075-14.35h-.987l-.875.875a1.452 1.452 0 0 0-.428 1.034c0 .39.152.757.428 1.033l.447.447c.42.42.652.978.652 1.573 0 .594-.231 1.153-.652 1.572l-.447.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.447.447c.42.42.652.979.652 1.573s-.231 1.153-.652 1.572l-.447.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.875.875h.987V16.579zm-2.066 0h-1.592l-.875.875a1.452 1.452 0 0 0-.428 1.034c0 .39.152.757.428 1.033l.447.447c.42.42.651.978.651 1.573 0 .594-.23 1.153-.651 1.572l-.447.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.447.447c.42.42.651.979.651 1.573s-.23 1.153-.651 1.572l-.447.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.875.875h1.592l-.335-.335a2.209 2.209 0 0 1-.652-1.573c0-.594.231-1.153.652-1.573l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.757-.428-1.033l-.447-.448a2.209 2.209 0 0 1-.652-1.572c0-.594.231-1.153.652-1.573l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.758-.428-1.033l-.447-.448a2.209 2.209 0 0 1-.652-1.572c0-.595.231-1.153.652-1.573l.335-.336zm-2.671 0h-1.593l-.875.875a1.452 1.452 0 0 0-.428 1.034c0 .39.152.757.428 1.033l.448.447c.42.42.651.978.651 1.573 0 .594-.231 1.153-.651 1.572l-.448.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.448.447c.42.42.651.979.651 1.573s-.231 1.153-.651 1.572l-.448.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.875.875h1.593l-.336-.335a2.209 2.209 0 0 1-.651-1.573c0-.594.23-1.153.651-1.573l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.757-.428-1.033l-.447-.448a2.209 2.209 0 0 1-.651-1.572c0-.594.23-1.153.651-1.573l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.758-.428-1.033l-.447-.448a2.209 2.209 0 0 1-.651-1.572c0-.595.23-1.153.651-1.573l.336-.336zm-2.672 0h-1.592l-.875.875a1.452 1.452 0 0 0-.428 1.034c0 .39.152.757.428 1.033l.447.447c.42.42.652.978.652 1.573 0 .594-.232 1.153-.652 1.572l-.447.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.447.447c.42.42.652.979.652 1.573s-.232 1.153-.652 1.572l-.447.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.875.875h1.592l-.335-.335a2.209 2.209 0 0 1-.652-1.573c0-.594.231-1.153.652-1.573l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.757-.428-1.033l-.447-.448a2.209 2.209 0 0 1-.652-1.572c0-.594.231-1.153.652-1.573l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.758-.428-1.033l-.447-.448a2.209 2.209 0 0 1-.652-1.572c0-.595.231-1.153.652-1.573l.335-.336zM18.87 31.945v.281c0 .13-.008.256-.022.382h.628l-.336-.335a2.238 2.238 0 0 1-.27-.328zm15.647-2.008a.382.382 0 1 0 .002.764.382.382 0 0 0-.002-.764zM15.435 12.763a2.674 2.674 0 0 0-2.672 2.671v14.638a3.428 3.428 0 0 1 5.343 0V15.434a2.674 2.674 0 0 0-2.671-2.67zm3.434 13.076v3.615c.079-.116.169-.225.27-.327l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.757-.428-1.033l-.447-.448a2.238 2.238 0 0 1-.27-.327zm15.647.281a.382.382 0 1 0 .002.765.382.382 0 0 0-.002-.765zM18.87 19.733v3.615c.079-.116.169-.225.27-.327l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.758-.428-1.033l-.447-.448a2.238 2.238 0 0 1-.27-.327zm15.647 2.57a.382.382 0 1 0 .002.765.382.382 0 0 0-.002-.764zm0-3.815a.382.382 0 1 0 .002.764.382.382 0 0 0-.002-.764zm-15.041-1.909h-.606v.663c.079-.116.169-.226.27-.327l.336-.336zm15.041-1.908a.382.382 0 1 0 .002.765.382.382 0 0 0-.002-.765z"
                fill="#e08b14"
                fill-rule="nonzero"
              />
            </svg>
          ),
          activeSvg: (
            <svg
              width="48"
              height="48"
              color="#fff"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="M15.435 12c1.188 0 2.236.607 2.854 1.526h13.938c.21 0 .381.171.381.382v.763h.834a1.143 1.143 0 0 1 1.074-.763c.632 0 1.145.514 1.145 1.145s-.513 1.145-1.145 1.145c-.496 0-.916-.32-1.074-.764h-.834v3.054h.834a1.143 1.143 0 0 1 1.074-.764c.632 0 1.145.514 1.145 1.145s-.513 1.145-1.145 1.145c-.496 0-.916-.32-1.074-.763h-.834v3.053h.834a1.143 1.143 0 0 1 1.074-.763c.632 0 1.145.513 1.145 1.145a1.143 1.143 0 0 1-2.22.382h-.833v3.052h.834a1.143 1.143 0 0 1 1.074-.763c.632 0 1.145.514 1.145 1.145s-.513 1.145-1.145 1.145c-.496 0-.916-.32-1.074-.763h-.834v3.053h.834a1.143 1.143 0 0 1 1.074-.764c.632 0 1.145.514 1.145 1.145s-.513 1.145-1.145 1.145c-.496 0-.916-.32-1.074-.763h-.834v3.053h.834a1.143 1.143 0 0 1 1.074-.763c.632 0 1.145.513 1.145 1.145a1.143 1.143 0 0 1-2.22.382h-.833v.762c0 .211-.17.382-.381.382H15.435A3.439 3.439 0 0 1 12 32.226V15.434A3.439 3.439 0 0 1 15.435 12zm0 17.555a2.674 2.674 0 0 0-2.672 2.671 2.674 2.674 0 0 0 2.672 2.672 2.674 2.674 0 0 0 2.671-2.672 2.674 2.674 0 0 0-2.671-2.671zm16.41-15.265H18.669c.128.358.2.743.2 1.144v.382h11.068c.21 0 .381.171.381.382V32.99c0 .21-.17.381-.381.381H18.669a3.445 3.445 0 0 1-1.08 1.527h14.256V14.29zm2.671 19.463a.382.382 0 1 0 .002.764.382.382 0 0 0-.002-.764zm-19.036-3.66a2.09 2.09 0 0 1 2.087 2.088 2.09 2.09 0 0 1-2.087 2.088 2.09 2.09 0 0 1-2.088-2.088 2.09 2.09 0 0 1 2.088-2.087zm0 .836c-.691 0-1.253.562-1.253 1.252 0 .691.562 1.253 1.253 1.253.69 0 1.252-.562 1.252-1.253 0-.69-.562-1.252-1.252-1.252zm14.075-14.35h-.987l-.875.875a1.452 1.452 0 0 0-.428 1.034c0 .39.152.757.428 1.033l.447.447c.42.42.652.978.652 1.573 0 .594-.231 1.153-.652 1.572l-.447.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.447.447c.42.42.652.979.652 1.573s-.231 1.153-.652 1.572l-.447.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.875.875h.987V16.579zm-2.066 0h-1.592l-.875.875a1.452 1.452 0 0 0-.428 1.034c0 .39.152.757.428 1.033l.447.447c.42.42.651.978.651 1.573 0 .594-.23 1.153-.651 1.572l-.447.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.447.447c.42.42.651.979.651 1.573s-.23 1.153-.651 1.572l-.447.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.875.875h1.592l-.335-.335a2.209 2.209 0 0 1-.652-1.573c0-.594.231-1.153.652-1.573l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.757-.428-1.033l-.447-.448a2.209 2.209 0 0 1-.652-1.572c0-.594.231-1.153.652-1.573l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.758-.428-1.033l-.447-.448a2.209 2.209 0 0 1-.652-1.572c0-.595.231-1.153.652-1.573l.335-.336zm-2.671 0h-1.593l-.875.875a1.452 1.452 0 0 0-.428 1.034c0 .39.152.757.428 1.033l.448.447c.42.42.651.978.651 1.573 0 .594-.231 1.153-.651 1.572l-.448.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.448.447c.42.42.651.979.651 1.573s-.231 1.153-.651 1.572l-.448.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.875.875h1.593l-.336-.335a2.209 2.209 0 0 1-.651-1.573c0-.594.23-1.153.651-1.573l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.757-.428-1.033l-.447-.448a2.209 2.209 0 0 1-.651-1.572c0-.594.23-1.153.651-1.573l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.758-.428-1.033l-.447-.448a2.209 2.209 0 0 1-.651-1.572c0-.595.23-1.153.651-1.573l.336-.336zm-2.672 0h-1.592l-.875.875a1.452 1.452 0 0 0-.428 1.034c0 .39.152.757.428 1.033l.447.447c.42.42.652.978.652 1.573 0 .594-.232 1.153-.652 1.572l-.447.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.447.447c.42.42.652.979.652 1.573s-.232 1.153-.652 1.572l-.447.448a1.452 1.452 0 0 0-.428 1.033c0 .39.152.757.428 1.033l.875.875h1.592l-.335-.335a2.209 2.209 0 0 1-.652-1.573c0-.594.231-1.153.652-1.573l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.757-.428-1.033l-.447-.448a2.209 2.209 0 0 1-.652-1.572c0-.594.231-1.153.652-1.573l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.758-.428-1.033l-.447-.448a2.209 2.209 0 0 1-.652-1.572c0-.595.231-1.153.652-1.573l.335-.336zM18.87 31.945v.281c0 .13-.008.256-.022.382h.628l-.336-.335a2.238 2.238 0 0 1-.27-.328zm15.647-2.008a.382.382 0 1 0 .002.764.382.382 0 0 0-.002-.764zM15.435 12.763a2.674 2.674 0 0 0-2.672 2.671v14.638a3.428 3.428 0 0 1 5.343 0V15.434a2.674 2.674 0 0 0-2.671-2.67zm3.434 13.076v3.615c.079-.116.169-.225.27-.327l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.757-.428-1.033l-.447-.448a2.238 2.238 0 0 1-.27-.327zm15.647.281a.382.382 0 1 0 .002.765.382.382 0 0 0-.002-.765zM18.87 19.733v3.615c.079-.116.169-.225.27-.327l.447-.447c.276-.276.428-.643.428-1.033 0-.39-.152-.758-.428-1.033l-.447-.448a2.238 2.238 0 0 1-.27-.327zm15.647 2.57a.382.382 0 1 0 .002.765.382.382 0 0 0-.002-.764zm0-3.815a.382.382 0 1 0 .002.764.382.382 0 0 0-.002-.764zm-15.041-1.909h-.606v.663c.079-.116.169-.226.27-.327l.336-.336zm15.041-1.908a.382.382 0 1 0 .002.765.382.382 0 0 0-.002-.765z"
                fill="#fff"
                fill-rule="nonzero"
              />
            </svg>
          ),
        },
        {
          title: texts.machine,
          color: "#e08b14",
          link: "https://shop.ghalichin.com/wiki/#tab_%D9%81%D8%B1%D8%B4-%D9%85%D8%A7%D8%B4%DB%8C%D9%86%DB%8C",
          svg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="M15.794 12.195c1.93.002 3.552 1.415 3.769 3.283h17.73v.82h-1.686v.822h1.686v.82h-1.686v.821h1.686v.821h-1.686v.821h1.686v.821h-1.686v.821h1.686v.82h-1.686v.822h1.686v.82h-1.686v.821h1.686v.821h-1.686v.821h1.686v.821h-1.686v.82h1.686v.822h-1.686v.82h1.686v.822h-1.686v.82h1.686v.821h-1.686v.821h1.686v.821h-1.686v.82h1.686V36H15.794c-2.094-.003-3.792-1.655-3.794-3.694V15.888a3.64 3.64 0 0 1 1.11-2.613 3.842 3.842 0 0 1 2.684-1.08zm18.97 4.104H19.588v1.231H30.97c.233 0 .421.184.421.41v1.642h1.438v-1.436h1.488v1.488l-1.037-.001c.13.07.22.204.22.36v11.492c0 .227-.19.41-.422.41H31.39v1.642c0 .227-.188.41-.421.41H19.187a3.73 3.73 0 0 1-1.014 1.232h16.59v-18.88zm-18.97 13.134c-1.63 0-2.95 1.286-2.95 2.873.001 1.586 1.321 2.871 2.95 2.873 1.63 0 2.95-1.286 2.95-2.873 0-1.587-1.32-2.873-2.95-2.873zm18.523 3.591v1.488H32.83v-1.488h1.487zM15.72 30.048a2.232 2.232 0 1 1 0 4.464 2.232 2.232 0 0 1 0-4.464zm0 .893a1.34 1.34 0 1 0 0 2.678 1.34 1.34 0 0 0 0-2.678zm14.828-12.59h-10.96v1.231h9.274c.233 0 .422.184.422.41v1.643h1.686c.233 0 .421.183.421.41v7.388c0 .226-.188.41-.421.41h-1.686v1.642c0 .227-.19.41-.422.41h-9.274v.41c0 .277-.034.553-.098.822h11.058v-1.642c0-.227.189-.41.422-.41h1.686V20.403H30.97a.416.416 0 0 1-.422-.41V18.35zm-2.107 2.052h-8.853v1.232h7.166c.233 0 .422.183.422.41v1.642h1.686c.233 0 .422.183.422.41v3.284c0 .226-.19.41-.422.41h-1.686v1.642c0 .226-.189.41-.422.41h-7.166v1.232h8.853v-1.642c0-.227.188-.41.421-.41h1.686v-6.568h-1.686a.416.416 0 0 1-.421-.41v-1.642zm-12.647-7.388c-1.63 0-2.95 1.287-2.95 2.873V29.99a3.825 3.825 0 0 1 2.95-1.377c1.147 0 2.232.507 2.95 1.377v-14.1c0-1.587-1.32-2.874-2.95-2.874zm10.539 9.44h-6.745v6.567h6.745v-1.641c0-.227.189-.41.421-.41h1.687v-2.463h-1.687a.416.416 0 0 1-.421-.41v-1.643z"
                fill="#e08b14"
                fill-rule="nonzero"
              />
            </svg>
          ),
          activeSvg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="M15.794 12.195c1.93.002 3.552 1.415 3.769 3.283h17.73v.82h-1.686v.822h1.686v.82h-1.686v.821h1.686v.821h-1.686v.821h1.686v.821h-1.686v.821h1.686v.82h-1.686v.822h1.686v.82h-1.686v.821h1.686v.821h-1.686v.821h1.686v.821h-1.686v.82h1.686v.822h-1.686v.82h1.686v.822h-1.686v.82h1.686v.821h-1.686v.821h1.686v.821h-1.686v.82h1.686V36H15.794c-2.094-.003-3.792-1.655-3.794-3.694V15.888a3.64 3.64 0 0 1 1.11-2.613 3.842 3.842 0 0 1 2.684-1.08zm18.97 4.104H19.588v1.231H30.97c.233 0 .421.184.421.41v1.642h1.438v-1.436h1.488v1.488l-1.037-.001c.13.07.22.204.22.36v11.492c0 .227-.19.41-.422.41H31.39v1.642c0 .227-.188.41-.421.41H19.187a3.73 3.73 0 0 1-1.014 1.232h16.59v-18.88zm-18.97 13.134c-1.63 0-2.95 1.286-2.95 2.873.001 1.586 1.321 2.871 2.95 2.873 1.63 0 2.95-1.286 2.95-2.873 0-1.587-1.32-2.873-2.95-2.873zm18.523 3.591v1.488H32.83v-1.488h1.487zM15.72 30.048a2.232 2.232 0 1 1 0 4.464 2.232 2.232 0 0 1 0-4.464zm0 .893a1.34 1.34 0 1 0 0 2.678 1.34 1.34 0 0 0 0-2.678zm14.828-12.59h-10.96v1.231h9.274c.233 0 .422.184.422.41v1.643h1.686c.233 0 .421.183.421.41v7.388c0 .226-.188.41-.421.41h-1.686v1.642c0 .227-.19.41-.422.41h-9.274v.41c0 .277-.034.553-.098.822h11.058v-1.642c0-.227.189-.41.422-.41h1.686V20.403H30.97a.416.416 0 0 1-.422-.41V18.35zm-2.107 2.052h-8.853v1.232h7.166c.233 0 .422.183.422.41v1.642h1.686c.233 0 .422.183.422.41v3.284c0 .226-.19.41-.422.41h-1.686v1.642c0 .226-.189.41-.422.41h-7.166v1.232h8.853v-1.642c0-.227.188-.41.421-.41h1.686v-6.568h-1.686a.416.416 0 0 1-.421-.41v-1.642zm-12.647-7.388c-1.63 0-2.95 1.287-2.95 2.873V29.99a3.825 3.825 0 0 1 2.95-1.377c1.147 0 2.232.507 2.95 1.377v-14.1c0-1.587-1.32-2.874-2.95-2.874zm10.539 9.44h-6.745v6.567h6.745v-1.641c0-.227.189-.41.421-.41h1.687v-2.463h-1.687a.416.416 0 0 1-.421-.41v-1.643z"
                fill="#fff"
                fill-rule="nonzero"
              />
            </svg>
          ),
        },
      ],
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37"
          height="43"
          viewBox="0 0 37 43"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <g stroke="#FFF" stroke-width="1.187">
              <g>
                <path
                  d="M35.358.102L.358.102.358 41.102 29.765 41.102 29.765 12.804 35.358 12.804zM33.358 41.102L35.358 41.102 35.358 31.102 33.358 31.102"
                  transform="translate(-930 -759) translate(930.908 760)"
                />
                <path
                  d="M33.358 27.102L35.358 27.102 35.358 17.102 33.358 17.102M4.358 38.102V4.148h17.964v-.046h4.036v33.954h-.291v.046H4.358zm4.037-4.154h13.926V8.302H8.395v25.646z"
                  transform="translate(-930 -759) translate(930.908 760)"
                />
                <path
                  d="M22.358 8.137v6.29l-5.086-6.29h5.086zm-5.115 25.93h5.086v-6.291l-5.086 6.29zM13.472 8.101l-5.086 6.29v-6.29h5.086zm-.029 26H8.358v-6.29l5.085 6.29zM14.857 11.102L20.358 20.602 14.857 30.102 9.358 20.602z"
                  transform="translate(-930 -759) translate(930.908 760)"
                />
              </g>
            </g>
          </g>
        </svg>
      ),
      img: "./static/img/daneshname-icon.png",
      boldText: texts.wikipediaBoldText,
      lightText: texts.wikipediaLightText,
      gif: "./static/gifs/01-daneshname.gif",
      description: texts.encyclopediaEndText,
      cardText: texts.first_step,
      video:
        "https://www.aparat.com/video/video/embed/videohash/4VReQ/vt/frame",
    },
    {
      title: texts.rugGenerate,
      name: "rugGenerate",
      bgColor: "linear-gradient(97deg, #3a31ea -14%, #d01657 100%)",
      color: "#c82d4a",
      iconGradiant: "#c82d4a",
      id: 3,
      Route: "https://rug.ghalichin.com",
      link: "https://rug.ghalichin.com",
      buttons: [
        {
          title: texts.market_carpet,
          color: "#c82d4a",
          link: "https://rug.ghalichin.com",
          svg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="m32.12 18.71-2.83-2.83a3 3 0 0 0-2.12-.88h-6.34a3 3 0 0 0-2.12.88l-2.83 2.83a3 3 0 0 0-.88 2.12V30a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-9.17a3 3 0 0 0-.88-2.12zM24 28a4 4 0 0 1-4-4 1 1 0 0 1 2 0 2 2 0 1 0 4 0 1 1 0 0 1 2 0 4 4 0 0 1-4 4zm-5.59-9 1.71-1.71a1.05 1.05 0 0 1 .71-.29h6.34c.265.004.518.107.71.29L29.59 19H18.41z"
                fill="#c82d4a"
                fill-rule="nonzero"
              />
            </svg>
          ),
          activeSvg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="m32.12 18.71-2.83-2.83a3 3 0 0 0-2.12-.88h-6.34a3 3 0 0 0-2.12.88l-2.83 2.83a3 3 0 0 0-.88 2.12V30a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-9.17a3 3 0 0 0-.88-2.12zM24 28a4 4 0 0 1-4-4 1 1 0 0 1 2 0 2 2 0 1 0 4 0 1 1 0 0 1 2 0 4 4 0 0 1-4 4zm-5.59-9 1.71-1.71a1.05 1.05 0 0 1 .71-.29h6.34c.265.004.518.107.71.29L29.59 19H18.41z"
                fill="#fff"
                fill-rule="nonzero"
              />
            </svg>
          ),
        },
        {
          title: texts.your_own_carpet,
          color: "#c82d4a",
          link: "https://rug.ghalichin.com",
          svg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <g fill={"#c82d4a"} fill-rule="nonzero">
                <path d="M23.943 23.906c0-1.228-1.285-2.226-2.82-2.226-.188 0-.374.02-.557.05v4.353c.183.03.369.05.557.05 1.535 0 2.82-.999 2.82-2.227z" />
                <path d="M20.566 28.36h3.704l1.9-1.901v-5.105l-1.9-1.9h-3.704v1.152c.184-.023.37-.04.557-.04 2.148 0 3.934 1.499 3.934 3.34 0 1.842-1.786 3.34-3.934 3.34-.187 0-.373-.017-.557-.04v1.153z" />
                <path d="M30.623 29.782V18.03a2.219 2.219 0 0 1-1.113-1.917H20.36a3.3 3.3 0 0 1 .205 1.114v1.113h4.164l2.553 2.553v6.027l-2.553 2.553h-4.164c0 .858-.334 1.634-.868 2.226h9.812c0-.82.45-1.53 1.113-1.917zm-2.783-.079-.787-.787.787-.787.787.787-.787.787zm0-10.02-.787-.787.787-.787.787.787-.787.788zM19.453 29.473a2.227 2.227 0 1 1-4.453 0 2.227 2.227 0 0 1 4.453 0zM30.623 31.7c0 .614.498 1.113 1.113 1.113H34v-2.227h-2.264c-.615 0-1.113.498-1.113 1.113zM30.623 16.113c0 .615.498 1.114 1.113 1.114H34V15h-2.264c-.615 0-1.113.498-1.113 1.113zM19.453 27.001v-9.774a2.227 2.227 0 0 0-4.453 0V27a3.315 3.315 0 0 1 2.227-.868c.858 0 1.634.334 2.226.868z" />
              </g>
            </svg>
          ),
          activeSvg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <g fill="#FFF" fill-rule="nonzero">
                <path d="M23.943 23.906c0-1.228-1.285-2.226-2.82-2.226-.188 0-.374.02-.557.05v4.353c.183.03.369.05.557.05 1.535 0 2.82-.999 2.82-2.227z" />
                <path d="M20.566 28.36h3.704l1.9-1.901v-5.105l-1.9-1.9h-3.704v1.152c.184-.023.37-.04.557-.04 2.148 0 3.934 1.499 3.934 3.34 0 1.842-1.786 3.34-3.934 3.34-.187 0-.373-.017-.557-.04v1.153z" />
                <path d="M30.623 29.782V18.03a2.219 2.219 0 0 1-1.113-1.917H20.36a3.3 3.3 0 0 1 .205 1.114v1.113h4.164l2.553 2.553v6.027l-2.553 2.553h-4.164c0 .858-.334 1.634-.868 2.226h9.812c0-.82.45-1.53 1.113-1.917zm-2.783-.079-.787-.787.787-.787.787.787-.787.787zm0-10.02-.787-.787.787-.787.787.787-.787.788zM19.453 29.473a2.227 2.227 0 1 1-4.453 0 2.227 2.227 0 0 1 4.453 0zM30.623 31.7c0 .614.498 1.113 1.113 1.113H34v-2.227h-2.264c-.615 0-1.113.498-1.113 1.113zM30.623 16.113c0 .615.498 1.114 1.113 1.114H34V15h-2.264c-.615 0-1.113.498-1.113 1.113zM19.453 27.001v-9.774a2.227 2.227 0 0 0-4.453 0V27a3.315 3.315 0 0 1 2.227-.868c.858 0 1.634.334 2.226.868z" />
              </g>
            </svg>
          ),
        },
        {
          title: texts.your_photo,
          color: "#c82d4a",
          link: "https://rug.ghalichin.com",
          svg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="M16 14h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2zm3 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-3 14v2h16v-6l-3-3-6 6-3-3-4 4z"
                fill="#c82d4a"
                fill-rule="nonzero"
              />
            </svg>
          ),
          activeSvg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="M16 14h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2zm3 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-3 14v2h16v-6l-3-3-6 6-3-3-4 4z"
                fill="#fff"
                fill-rule="nonzero"
              />
            </svg>
          ),
        },
      ],
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="49"
          height="30"
          viewBox="0 0 49 30"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#FFF">
              <path
                d="M789.605 794.824c.383-.353.988-.581 1.67-.581.681 0 1.287.228 1.669.581-.382.353-.988.581-1.669.581-.682 0-1.287-.228-1.67-.58zm12.424-22.15c.039.002.074.024.093.059.021.037.02.082-.002.117l-.044.07-.117.194c.249.009.469.132.611.318-.147.194-.38.32-.641.32-.113 0-.22-.024-.318-.066l-1.277 2.102c.251.008.473.131.615.318-.147.194-.379.32-.641.32-.114 0-.222-.024-.321-.067l-1.277 2.103c.252.007.476.13.618.319-.146.194-.379.319-.641.319-.115 0-.224-.025-.323-.068l-1.279 2.104c.254.006.479.13.623.319-.147.194-.38.319-.641.319-.117 0-.227-.025-.327-.07l-1.279 2.106c.255.005.482.129.626.319-.147.194-.379.32-.641.32-.117 0-.229-.026-.33-.072l-1.28 2.107c.257.004.485.128.63.32-.147.193-.379.318-.641.318-.118 0-.231-.025-.333-.072l-1.28 2.109c.258.002.488.126.634.318-.147.194-.38.32-.641.32-.12 0-.234-.027-.336-.074l-1.282 2.11c.26 0 .492.126.638.319-.147.193-.379.319-.641.319-.121 0-.236-.027-.339-.075l-1.283 2.11h.001c.262 0 .494.126.641.32-.147.194-.379.319-.641.319-.122 0-.238-.028-.342-.077l-.139.23c-.028.046-.078.074-.131.074h-17.558v-.009h-7.119c-3.68 0-6.674-2.994-6.674-6.673 0-1.319.397-2.541 1.059-3.577l.233-.334c1.214-1.666 3.167-2.763 5.382-2.763 2.944 0 5.339 2.395 5.339 5.339 0 2.944-2.395 5.339-5.339 5.339-2.208 0-4.004-1.796-4.004-4.004 0-2.208 1.796-4.004 4.004-4.004.18 0 .354.018.524.052.473.077 1.004.37 1.302.671.519.488.843 1.18.843 1.946 0 1.472-1.198 2.67-2.669 2.67-.737 0-1.335-.599-1.335-1.335 0-.737.599-1.335 1.335-1.335.22 0 .426-.11.551-.29l.041-.061c.23-.602-.186-1.145-.962-.958-1.297.18-2.3 1.297-2.3 2.644 0 1.471 1.198 2.67 2.67 2.67 2.208 0 4.004-1.797 4.004-4.005s-1.796-4.004-4.004-4.004c-2.945 0-5.339 2.394-5.339 5.339 0 2.944 2.394 5.338 5.339 5.338 2.59 0 4.816-1.499 5.921-3.661l.024.014 10.042-15.988c.195-.315.35-.647.477-.99.163-.436.58-.725 1.046-.725 1.352-.005 3.908-.005 3.908-.005h-.001 8.288-.001 8.651zm-17.671 17.56c.223.008.451.103.56.3.21.381.015.845-.161 1.18-.35.476-.27.39-.629.777-.425.343-.993.483-1.566.283-.267-.096-.531-.235-.818-.19-.336.054-.797.533-1.134.955-.077.09-.095.215-.046.323.049.107.157.176.275.177 1.365.01 4.706.014 6.199.017.462 0 .89-.239 1.131-.632 1.044-1.706 2.085-3.414 3.128-5.12l-.207.045c-.616.13-1.292.263-1.855.014-.432-.19-.487-.745-.054-1.293.326-.413.755-.74 1.035-1.186.211-.336-.445-.713-1.45-.37-.39.134-.743.392-.915.762-.247.53-.308 1.163-.704 1.602-.687.762-2.025.667-3.071.344l-.021-.007c-.165.182-.333.362-.498.544l-.079.089c-.413.478-.84.983-.933 1.604-.011.09.149.089.149.089.556-.05 1.054-.318 1.664-.307zm6.867 1.918c.185-.245.479-.404.81-.404.331 0 .625.159.811.404-.186.245-.48.403-.811.403-.331 0-.625-.158-.81-.403zm-9.856-9.726c.132.009.262.058.354.152.327.334.167.866.013 1.227-.257.6-.691 1.14-1.233 1.513-.242.167-.524.295-.822.297-.496.003-.941-.37-1.39-.314-.544.068-.885.584-1.141 1-.063.103-.122.208-.179.315-.058.11-.114.222-.167.335-.057.12-.043.263.038.37.08.106.213.16.345.137.065-.01.132-.022.198-.03.443-.063.922-.1 1.325.068.308.13.51.492.353.849-.057.13-.132.253-.217.369-.341.467-.858.81-1.125 1.316-.067.126-.042.283.102.363.091.05.189.084.29.105.038.008.075.014.113.019.049.006.098.01.147.01.723.019 1.493-.349 1.769-1 .254-.6.331-1.326.907-1.745.817-.593 1.96-.415 2.861-.13.59-.66 1.244-1.305 1.491-2.157.079-.275-.103-.195-.293-.17-.494.067-.959.301-1.455.296-.34-.004-.665-.198-.674-.623-.02-.905.738-1.736 1.39-2.228.253-.191.554-.342.877-.345.5-.003.948.376 1.4.313.51-.07.842-.545 1.088-.934.062-.099.121-.2.177-.303.166-.302.307-.616.434-.937l.034-.085c-.229.054-.46.106-.692.145-.129.021-.258.039-.387.05-.106.01-.213.015-.32.015-.083 0-.167-.002-.25-.009-.06-.004-.12-.01-.18-.02-.466-.065-.957-.378-.7-.966.175-.403.526-.704.849-1.03l.075-.075c.319-.336.718-.744.195-.934-.409-.15-.898-.069-1.293.07-.561.198-.898.71-1.114 1.423-.207.67-.655 1.282-1.465 1.466-.698.159-1.427.026-2.103-.191l-.009-.003c-.62.685-1.365 1.373-1.481 2.204-.005.033-.058.072.035.092.496.108 1.088-.287 1.767-.29h.063zm11.477 7.051c.185-.245.479-.403.81-.403.331 0 .625.158.81.403-.185.245-.479.404-.81.404-.331 0-.625-.159-.81-.404zm-2.059-9.405c-.619.01-1.236.128-1.844.27-.363 1.062-.78 2.182-1.781 2.732-.295.162-.646.196-.984.103-.344-.095-.668-.307-1.004-.253-.489.078-.871.512-1.192.92-.246.312-.457.66-.505 1.045-.014.11-.066.233.099.24.61.029 1.233-.445 1.913-.306.197.04.365.187.418.386.097.362-.136.707-.31 1.012-.06.104-.123.207-.188.309-.075.115-.153.229-.234.34-.238.327-.496.638-.762.943.876.238 1.937.313 2.439-.334.309-.4.339-.953.577-1.422.523-1.028 2.143-1.612 3.066-.926.228.17.365.457.257.785-.239.72-1.131 1.12-1.423 1.836-.144.356.813.244 1.473.14.279-.045.556-.102.832-.167l4.568-7.447-.089-.024c-.257-.068-.518-.12-.781-.144-.083-.007-.166-.012-.249-.014-.065-.002-.131-.001-.197.001-.057.003-.114.007-.17.013-.382.04-.778.18-1.021.491-.412.529-.429 1.306-.868 1.835-.732.88-2.49 1.095-2.99.274-.234-.385.096-.896.386-1.216.147-.164.308-.316.463-.472.213-.217.441-.441.542-.714.051-.137-.177-.232-.397-.236h-.044zm3.679 6.731c.186-.245.48-.403.811-.403.33 0 .624.158.81.403-.186.245-.48.404-.81.404-.331 0-.625-.159-.811-.404zm-24.588-18.638c.932-1.356 2.47-2.165 4.222-2.165.539 0 1.07.086 1.58.257l.183.061c1.63.544 2.85 1.861 3.265 3.526.326 1.302.107 2.704-.599 3.842l-7.862 12.516c-.056.09-.163.136-.267.115-.105-.02-.186-.102-.205-.207-.583-3.083-3.27-5.428-6.521-5.428-.914 0-1.79.159-2.608.443-.042.015-.088.001-.115-.034-.027-.035-.028-.084-.003-.12l8.93-12.806zm26.209 15.964c.185-.245.479-.403.81-.403.331 0 .625.158.811.403-.186.245-.48.404-.811.404-.331 0-.625-.159-.81-.404zm3.487-10.141c.095 0 .182.051.228.134.047.083.045.184-.005.265l-3.329 5.423-.035-.012c-.725-.228-1.516-.344-2.24-.104-.843.279-1.116 1.002-1.339 1.719-.21.635-.66 1.03-1.208 1.17-.369.096-.785.142-1.136-.001-.097-.04-.25-.097-.245-.227.003-.075.063-.151.066-.157.291-.462.734-.796 1.068-1.23.056-.074.107-.148.107-.148.22-.282.332-.678.131-.946-.373-.495-1.468-.309-2.327-.138l-.18.038.01-.027c.128-.329.272-.652.44-.963.056-.105.115-.209.179-.31.248-.399.582-.887 1.102-.962.325-.047.636.148.965.244.57.168 1.074-.053 1.463-.384.061-.053.071-.057.2-.185.379-.349.704-.764.891-1.243.121-.32.293-.848-.02-1.162-.11-.112-.274-.155-.433-.16-.379-.006-.745.121-1.109.226-.259.072-.752.105-.723-.036.061-.302.22-.573.396-.824h7.083zm-1.866 7.467c.185-.245.479-.404.81-.404.331 0 .625.159.81.404-.185.245-.479.403-.81.403-.331 0-.625-.158-.81-.403zm-5.772-7.467l-.014.026c-.165.29-.347.574-.339.884.01.385.384.553.694.547.627-.01 1.177-.393 1.699-.322.127.02.052.271.052.271-.055.356-.244.678-.465.967-.413.538-.982 1.1-1.569.941-.558-.151-1.153-.394-1.639-.13-1.009.546-1.425 1.673-1.788 2.735l-.102.024c-.616.138-1.239.276-1.85.245-.252-.013-.373-.176-.287-.332.316-.57.905-.91 1.233-1.447.258-.423.196-.891-.129-1.114-.718-.493-1.787-.25-2.488.28l-.049.04c-.532.387-.624 1.054-.86 1.641-.442 1.101-1.649 1.019-2.658.745 0 0 .556-.659.789-.985.076-.106.148-.214.218-.323.235-.372.556-.767.468-1.225-.054-.28-.312-.425-.577-.441l-.058-.002c-.359 0-.703.117-1.047.214-.351.096-.796.223-.771-.013.058-.476.288-.881.583-1.239.347-.42.742-.836 1.218-.852.405-.014.819.304 1.276.318.781.025 1.311-.665 1.71-1.332.044-.075.125-.121.212-.121h6.538zm7.392 4.793c.186-.245.48-.404.811-.404.33 0 .624.159.81.404-.186.245-.48.403-.81.403-.331 0-.625-.158-.811-.403zm1.621-2.674c.185-.245.479-.404.81-.404.331 0 .625.159.811.404-.186.245-.48.403-.811.403-.331 0-.625-.159-.81-.404zm1.621-2.676c.382-.353.988-.581 1.669-.581s1.287.228 1.669.581c-.382.353-.988.581-1.669.581s-1.287-.228-1.669-.58z"
                transform="translate(-757 -766)"
              />
            </g>
          </g>
        </svg>
      ),
      img: "./static/img/chideman-icon.png",
      boldText: texts.layOutBoldText,
      lightText: texts.layOutLightText,
      description: texts.generatorEndText,
      cardText: texts.scond_step,
      gif: "./static/gifs/02-chideman.gif",
      video:
        "https://www.aparat.com/video/video/embed/videohash/9twEQ/vt/frame",
    },
    {
      title: texts.vr,
      id: 4,
      name: "vr",
      bgColor: "linear-gradient(97deg, #3a31ea -14%, #d01657 100%)",
      color: "#06b170",
      iconGradiant: "#06b170",
      buttons: [
        {
          title: texts.Two_dimensional,
          color: "#06b170",
          route: "/room",
          svg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="m32.12 18.71-2.83-2.83a3 3 0 0 0-2.12-.88h-6.34a3 3 0 0 0-2.12.88l-2.83 2.83a3 3 0 0 0-.88 2.12V30a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-9.17a3 3 0 0 0-.88-2.12zM24 28a4 4 0 0 1-4-4 1 1 0 0 1 2 0 2 2 0 1 0 4 0 1 1 0 0 1 2 0 4 4 0 0 1-4 4zm-5.59-9 1.71-1.71a1.05 1.05 0 0 1 .71-.29h6.34c.265.004.518.107.71.29L29.59 19H18.41z"
                fill="#06b170"
                fill-rule="nonzero"
              />
            </svg>
          ),
          activeSvg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="m32.12 18.71-2.83-2.83a3 3 0 0 0-2.12-.88h-6.34a3 3 0 0 0-2.12.88l-2.83 2.83a3 3 0 0 0-.88 2.12V30a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-9.17a3 3 0 0 0-.88-2.12zM24 28a4 4 0 0 1-4-4 1 1 0 0 1 2 0 2 2 0 1 0 4 0 1 1 0 0 1 2 0 4 4 0 0 1-4 4zm-5.59-9 1.71-1.71a1.05 1.05 0 0 1 .71-.29h6.34c.265.004.518.107.71.29L29.59 19H18.41z"
                fill="#fff"
                fill-rule="nonzero"
              />
            </svg>
          ),
        },
        {
          title: texts.threeD,
          color: "#06b170",
          link: "http://planner.ghalichin.com/",
          svg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <g fill="#06b170" fill-rule="nonzero">
                <path d="M30.125 24v1.113c1.146.545 1.812 1.219 1.812 1.887 0 1.533-3.242 2.737-6.45 2.99a.514.514 0 0 0-.485.546.524.524 0 0 0 .573.463C28.367 30.78 33 29.634 33 27c0-1.438-1.48-2.428-2.875-3zM20.867 28.237c-.295-.283-.807-.145-.897.245l-.234 1.015c-3.513-.894-5.199-2.816-1.861-4.393V24c-4.38 1.786-3.693 5.141 1.634 6.478l-.21.913c-.091.39.32.722.715.572l2.652-1.003a.49.49 0 0 0 .182-.817l-1.98-1.906zM23.728 17.066a.528.528 0 0 0-.516.002L19 19.453 23.5 22l4.5-2.56-4.272-2.374zM19 25.013c0 .191.1.368.264.464L23.571 28v-5.322L19 20v5.013zM28 25.018V20l-4 2.429V28l3.77-2.519a.555.555 0 0 0 .23-.463z" />
              </g>
            </svg>
          ),
          activeSvg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <g fill="#fff" fill-rule="nonzero">
                <path d="M30.125 24v1.113c1.146.545 1.812 1.219 1.812 1.887 0 1.533-3.242 2.737-6.45 2.99a.514.514 0 0 0-.485.546.524.524 0 0 0 .573.463C28.367 30.78 33 29.634 33 27c0-1.438-1.48-2.428-2.875-3zM20.867 28.237c-.295-.283-.807-.145-.897.245l-.234 1.015c-3.513-.894-5.199-2.816-1.861-4.393V24c-4.38 1.786-3.693 5.141 1.634 6.478l-.21.913c-.091.39.32.722.715.572l2.652-1.003a.49.49 0 0 0 .182-.817l-1.98-1.906zM23.728 17.066a.528.528 0 0 0-.516.002L19 19.453 23.5 22l4.5-2.56-4.272-2.374zM19 25.013c0 .191.1.368.264.464L23.571 28v-5.322L19 20v5.013zM28 25.018V20l-4 2.429V28l3.77-2.519a.555.555 0 0 0 .23-.463z" />
              </g>
            </svg>
          ),
        },
        {
          title: texts.virtual_tour,
          color: "#06b170",
          route: "/virtualTour",
          svg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <g fill="#06b170" fill-rule="nonzero">
                <path d="M20 25.694a3.15 3.15 0 0 1-1.015-.346l-.645.896c.505.29 1.07.478 1.66.553V31l-6-1.066V15l6 1.065v9.629zm-2.384-2.587h-1.192c0 .845.308 1.642.893 2.305l.936-.66a2.462 2.462 0 0 1-.637-1.645zM27 21.362v9.74L21 32V16.898L27 16v4.28c-.79.103-1.544.396-2.15.869l.787.814c.395-.308.86-.51 1.363-.601zm-5.354 5.09.5.98c.852-.35 1.558-.955 1.988-1.703l-1.067-.495a2.905 2.905 0 0 1-1.42 1.218zm2.317-4.338A3.477 3.477 0 0 0 23.4 24c0 .13-.01.258-.03.383l1.188.154c.027-.176.042-.354.042-.537 0-.474.139-.94.4-1.347l-1.037-.54zM28 16l6 1.066V32l-6-1.065V16zm2.384 7.892v1.067h1.192v-1.066c0-.356-.056-.71-.167-1.05l-1.144.3c.08.243.12.495.12.75zm-.552-1.543.97-.618c-.541-.68-1.33-1.182-2.223-1.416l-.335 1.022c.637.167 1.2.526 1.588 1.012z" />
              </g>
            </svg>
          ),
          activeSvg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <g fill="#fff" fill-rule="nonzero">
                <path d="M20 25.694a3.15 3.15 0 0 1-1.015-.346l-.645.896c.505.29 1.07.478 1.66.553V31l-6-1.066V15l6 1.065v9.629zm-2.384-2.587h-1.192c0 .845.308 1.642.893 2.305l.936-.66a2.462 2.462 0 0 1-.637-1.645zM27 21.362v9.74L21 32V16.898L27 16v4.28c-.79.103-1.544.396-2.15.869l.787.814c.395-.308.86-.51 1.363-.601zm-5.354 5.09.5.98c.852-.35 1.558-.955 1.988-1.703l-1.067-.495a2.905 2.905 0 0 1-1.42 1.218zm2.317-4.338A3.477 3.477 0 0 0 23.4 24c0 .13-.01.258-.03.383l1.188.154c.027-.176.042-.354.042-.537 0-.474.139-.94.4-1.347l-1.037-.54zM28 16l6 1.066V32l-6-1.065V16zm2.384 7.892v1.067h1.192v-1.066c0-.356-.056-.71-.167-1.05l-1.144.3c.08.243.12.495.12.75zm-.552-1.543.97-.618c-.541-.68-1.33-1.182-2.223-1.416l-.335 1.022c.637.167 1.2.526 1.588 1.012z" />
              </g>
            </svg>
          ),
        },
      ],
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="45"
          height="43"
          viewBox="0 0 45 43"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <g stroke="#FFF" stroke-width="1.243">
              <g>
                <path
                  d="M21.834 35.244v-19.52l12.265-4.395v-.027l2.756-.987v19.52l-.199.071v.027l-14.822 5.31zm2.757-3.376l9.508-3.407V13.717l-9.508 3.407v14.744z"
                  transform="translate(-587 -759) translate(588 760)"
                />
                <path
                  d="M34.099 13.737v3.567l-3.449-2.331 3.449-1.236zm-3.468 15.947l3.448-1.236v-3.567l-3.448 4.803zm-2.557-13.808l-3.449 4.803V17.11l3.449-1.235zm-.019 14.75l-3.449 1.236v-3.567l3.449 2.332zM29.345 17.204L32.943 21.503 29.345 28.381 25.747 24.082z"
                  transform="translate(-587 -759) translate(588 760)"
                />
                <path
                  d="M36.855 29.864L21.834 35.228 21.834 15.697 36.855 10.332zM21.834 35.228L6.813 29.864 6.813 10.332 21.834 15.697z"
                  transform="translate(-587 -759) translate(588 760)"
                />
                <path
                  d="M21.932 4.968L6.813 10.332 21.834 15.697 36.855 10.332zM.5.5L.5 5.09M.5.5L5.09.5M.5 40.913L.5 36.323M.5 40.913L5.09 40.913M43.168.5L43.168 5.09M43.168.5L38.579.5M43.168 40.913L43.168 36.323M43.168 40.913L38.579 40.913"
                  transform="translate(-587 -759) translate(588 760)"
                />
              </g>
            </g>
          </g>
        </svg>
      ),
      img: "./static/img/vagheiat-icon.png",
      boldText: texts.VRBoldText,
      lightText: texts.VRLightText,
      description: texts.vrEndText,
      gif: "./static/gifs/03-Ar.gif",
      cardText: texts.third_step,
      video:
        "https://www.aparat.com/video/video/embed/videohash/8VkCW/vt/frame",
    },
    {
      title: texts.buy,
      name: "buy",
      id: 5,
      bgColor: "linear-gradient(97deg, #3a31ea -14%, #d01657 100%)",
      color: "#146bf0",
      iconGradiant: "#146bf0",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27"
          height="44"
          viewBox="0 0 27 44"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <g stroke="#FFF" stroke-width="1.179">
              <g>
                <path
                  d="M3.711 40.38V12.416h15.513v-.038h3.487v27.962h-.251v.038H3.71zm3.487-3.421h12.027V15.838H7.198v21.12z"
                  transform="translate(-437 -758) translate(437 759)"
                />
                <path
                  d="M19.711 15.408v5.08l-4.36-5.08h4.36zM15.327 36.35h4.36V31.27l-4.36 5.08zm-3.232-20.972l-4.36 5.081v-5.08h4.36zm-.024 21H7.71V31.3l4.36 5.08zM13.21 18.379L17.711 26.379 13.21 34.379 8.711 26.379zM20.711 10.38V7.481c0-3.731-2.738-7.103-6.334-7.103h-.114c-3.595 0-6.552 3.372-6.552 7.103v2.897"
                  transform="translate(-437 -758) translate(437 759)"
                />
                <path
                  d="M25.711 38.176L25.711 42.379 0.711 42.379 0.711 9.379 25.711 9.379 25.711 39.293"
                  transform="translate(-437 -758) translate(437 759)"
                />
              </g>
            </g>
          </g>
        </svg>
      ),

      buttons: [
        {
          title: texts.market,
          color: "#146bf0",
          link: "https://shop.ghalichin.com",
          svg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="m20.123 21.25.791-5.25H16.8l-1.719 4.5c-.053.16-.081.326-.081.5 0 1.104 1.15 2 2.571 2 1.31 0 2.393-.764 2.552-1.75zM24 23c1.42 0 2.571-.896 2.571-2 0-.041-.003-.082-.005-.121L26.057 16h-4.114l-.51 4.875c-.002.041-.004.082-.004.125 0 1.104 1.151 2 2.571 2zm5 1.046V28H19v-3.948c-.438.158-.92.248-1.429.248-.195 0-.384-.023-.571-.049V30.6c0 .77.629 1.4 1.398 1.4H29.6c.77 0 1.4-.631 1.4-1.4v-6.348a4.297 4.297 0 0 1-.571.049A4.155 4.155 0 0 1 29 24.046zm3.92-3.546L31.199 16h-4.113l.79 5.242c.154.99 1.237 1.758 2.553 1.758 1.42 0 2.571-.896 2.571-2 0-.174-.028-.34-.08-.5z"
                fill="#146bf0"
                fill-rule="nonzero"
              />
            </svg>
          ),

          activeSvg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="m20.123 21.25.791-5.25H16.8l-1.719 4.5c-.053.16-.081.326-.081.5 0 1.104 1.15 2 2.571 2 1.31 0 2.393-.764 2.552-1.75zM24 23c1.42 0 2.571-.896 2.571-2 0-.041-.003-.082-.005-.121L26.057 16h-4.114l-.51 4.875c-.002.041-.004.082-.004.125 0 1.104 1.151 2 2.571 2zm5 1.046V28H19v-3.948c-.438.158-.92.248-1.429.248-.195 0-.384-.023-.571-.049V30.6c0 .77.629 1.4 1.398 1.4H29.6c.77 0 1.4-.631 1.4-1.4v-6.348a4.297 4.297 0 0 1-.571.049A4.155 4.155 0 0 1 29 24.046zm3.92-3.546L31.199 16h-4.113l.79 5.242c.154.99 1.237 1.758 2.553 1.758 1.42 0 2.571-.896 2.571-2 0-.174-.028-.34-.08-.5z"
                fill="#fff"
                fill-rule="nonzero"
              />
            </svg>
          ),
        },
        {
          title: texts.gazette,
          color: "#146bf0",
          link: "https://shop.ghalichin.com/mag/",
          svg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="m24.526 19.213.446 1.37a4.135 4.135 0 0 1 1.441-.794c.59-.192 1.111-.3 1.582-.362l-.43-1.323a9.465 9.465 0 0 0-1.58.368 5.25 5.25 0 0 0-1.459.74zm.927 2.855.446 1.37a4.135 4.135 0 0 1 1.441-.794c.59-.192 1.111-.3 1.582-.362l-.43-1.323a9.465 9.465 0 0 0-1.58.368 5.21 5.21 0 0 0-1.459.74zm.928 2.854.446 1.37a4.135 4.135 0 0 1 1.441-.794c.59-.192 1.111-.3 1.582-.362l-.43-1.323a9.465 9.465 0 0 0-1.58.368 5.21 5.21 0 0 0-1.459.74zm-7.062 2.172.43 1.323a8.745 8.745 0 0 1 1.492-.636 4.141 4.141 0 0 1 1.633-.203l-.446-1.371a5.25 5.25 0 0 0-1.615.257 9.406 9.406 0 0 0-1.494.63zm-1.855-5.71.43 1.324a8.825 8.825 0 0 1 1.492-.636 4.141 4.141 0 0 1 1.633-.203l-.445-1.372a5.263 5.263 0 0 0-1.616.258 9.406 9.406 0 0 0-1.494.63zm.927 2.856.43 1.323a8.745 8.745 0 0 1 1.492-.636 4.141 4.141 0 0 1 1.633-.203l-.445-1.372a5.25 5.25 0 0 0-1.615.257 9.417 9.417 0 0 0-1.495.63zm6.604-8.813a5.26 5.26 0 0 0-3.053 2.559 5.257 5.257 0 0 0-3.973-.275C15.446 18.53 14 20.338 14 20.338l4.095 12.587c.126.387.646.477.878.143.499-.72 1.46-1.658 3.257-2.242 1.718-.558 2.969.054 3.655.578.272.208.662.06.762-.268.252-.827.907-2.04 2.61-2.593 1.799-.585 3.129-.39 3.956-.1.385.134.75-.242.625-.63L29.75 15.22s-2.232-.612-4.755.207zm-.113 13.846a5.208 5.208 0 0 0-3.141.044c-1.251.406-2.127.949-2.699 1.404l-3.245-9.982c.358-.358 1.187-1.042 2.662-1.521 1.389-.451 2.528-.065 3.279.378l3.144 9.677zm6.894-2.69c-.731-.031-1.759.045-3.01.452a5.205 5.205 0 0 0-2.567 1.81l-3.144-9.677c.346-.8 1.04-1.782 2.43-2.233 1.474-.48 2.547-.413 3.047-.334l3.244 9.983z"
                fill="#146bf0"
                fill-rule="nonzero"
              />
            </svg>
          ),
          activeSvg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="m24.526 19.213.446 1.37a4.135 4.135 0 0 1 1.441-.794c.59-.192 1.111-.3 1.582-.362l-.43-1.323a9.465 9.465 0 0 0-1.58.368 5.25 5.25 0 0 0-1.459.74zm.927 2.855.446 1.37a4.135 4.135 0 0 1 1.441-.794c.59-.192 1.111-.3 1.582-.362l-.43-1.323a9.465 9.465 0 0 0-1.58.368 5.21 5.21 0 0 0-1.459.74zm.928 2.854.446 1.37a4.135 4.135 0 0 1 1.441-.794c.59-.192 1.111-.3 1.582-.362l-.43-1.323a9.465 9.465 0 0 0-1.58.368 5.21 5.21 0 0 0-1.459.74zm-7.062 2.172.43 1.323a8.745 8.745 0 0 1 1.492-.636 4.141 4.141 0 0 1 1.633-.203l-.446-1.371a5.25 5.25 0 0 0-1.615.257 9.406 9.406 0 0 0-1.494.63zm-1.855-5.71.43 1.324a8.825 8.825 0 0 1 1.492-.636 4.141 4.141 0 0 1 1.633-.203l-.445-1.372a5.263 5.263 0 0 0-1.616.258 9.406 9.406 0 0 0-1.494.63zm.927 2.856.43 1.323a8.745 8.745 0 0 1 1.492-.636 4.141 4.141 0 0 1 1.633-.203l-.445-1.372a5.25 5.25 0 0 0-1.615.257 9.417 9.417 0 0 0-1.495.63zm6.604-8.813a5.26 5.26 0 0 0-3.053 2.559 5.257 5.257 0 0 0-3.973-.275C15.446 18.53 14 20.338 14 20.338l4.095 12.587c.126.387.646.477.878.143.499-.72 1.46-1.658 3.257-2.242 1.718-.558 2.969.054 3.655.578.272.208.662.06.762-.268.252-.827.907-2.04 2.61-2.593 1.799-.585 3.129-.39 3.956-.1.385.134.75-.242.625-.63L29.75 15.22s-2.232-.612-4.755.207zm-.113 13.846a5.208 5.208 0 0 0-3.141.044c-1.251.406-2.127.949-2.699 1.404l-3.245-9.982c.358-.358 1.187-1.042 2.662-1.521 1.389-.451 2.528-.065 3.279.378l3.144 9.677zm6.894-2.69c-.731-.031-1.759.045-3.01.452a5.205 5.205 0 0 0-2.567 1.81l-3.144-9.677c.346-.8 1.04-1.782 2.43-2.233 1.474-.48 2.547-.413 3.047-.334l3.244 9.983z"
                fill="#fff"
                fill-rule="nonzero"
              />
            </svg>
          ),
        },
      ],

      img: "./static/img/kharid-icon.png",
      boldText: texts.shoppingBoldText,
      lightText: texts.shoppingLightText,
      description: texts.buyEndText,
      gif: "./static/gifs/04-shop.gif",
      cardText: texts.fourth_step,
      video:
        "https://www.aparat.com/video/video/embed/videohash/odnFf/vt/frame",
    },
    {
      title: texts.insuranceAndServices,
      name: "insuranceAndServices",
      bgColor: "linear-gradient(97deg, #3a31ea -14%, #d01657 100%)",
      color: "#5b32d9",
      id: 6,
      iconGradiant: "#5b32d9",
      buttons: [
        {
          title: texts.inshurance,
          color: "#5b32d9",
          link: "http://shop.ghalichin.com/insurance/",
          svg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="m32.614 28 2.21 2.244a.619.619 0 0 1-.236 1.014l-2.454.83-.818 2.493a.597.597 0 0 1-.998.24l-2.901-2.946c.506-.092.96-.4 1.232-.852l.16-.269.31.026c1.209.1 1.784-.884 1.906-1.407l.071-.306.301-.072A1.806 1.806 0 0 0 32.614 28zm-16.228 0c.228.487.664.861 1.217.995l.3.072.072.306c.122.523.697 1.507 1.906 1.407l.31-.026.16.269c.271.452.726.76 1.232.852l-2.9 2.946a.597.597 0 0 1-.999-.24l-.818-2.492-2.454-.83a.619.619 0 0 1-.236-1.014zm7.425-13.853a.61.61 0 0 1 .795 0l.809.694.983-.41a.61.61 0 0 1 .757.246l.554.91 1.063-.086c.3-.025.574.174.643.467l.247 1.037 1.036.247a.61.61 0 0 1 .468.643l-.086 1.062.91.555a.61.61 0 0 1 .245.756l-.41.984.694.809a.61.61 0 0 1 0 .795l-.694.809.41.984a.61.61 0 0 1-.245.756l-.91.555.086 1.062a.61.61 0 0 1-.468.643l-1.036.247-.247 1.037a.611.611 0 0 1-.643.467l-1.063-.086-.554.91a.61.61 0 0 1-.757.246l-.983-.41-.809.693a.61.61 0 0 1-.795 0l-.809-.694-.984.41a.61.61 0 0 1-.756-.245l-.555-.91-1.062.086A.61.61 0 0 1 19 28.95l-.246-1.037-1.037-.247a.61.61 0 0 1-.467-.643l.086-1.062-.91-.555a.61.61 0 0 1-.246-.756l.41-.984-.694-.809a.61.61 0 0 1 0-.795l.694-.81-.41-.983a.61.61 0 0 1 .246-.756l.91-.555-.086-1.062a.61.61 0 0 1 .467-.643l1.037-.247.246-1.037a.61.61 0 0 1 .644-.467l1.062.086.555-.91a.61.61 0 0 1 .756-.246l.984.41zm3.557 4.722a.61.61 0 0 0-.863 0l-2.95 2.95-1.316-1.315a.61.61 0 0 0-.864 0l-1.85 1.85a.61.61 0 0 0 0 .863l3.598 3.597a.61.61 0 0 0 .863 0l5.232-5.232a.61.61 0 0 0 0-.863zm-.34 1.548.972.967-4.306 4.283L21 22.987l.972-.967 1.297 1.29a.604.604 0 0 0 .85 0l2.909-2.893z"
                fill="#5b32d9"
                fill-rule="nonzero"
              />
            </svg>
          ),
          activeSvg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="m32.614 28 2.21 2.244a.619.619 0 0 1-.236 1.014l-2.454.83-.818 2.493a.597.597 0 0 1-.998.24l-2.901-2.946c.506-.092.96-.4 1.232-.852l.16-.269.31.026c1.209.1 1.784-.884 1.906-1.407l.071-.306.301-.072A1.806 1.806 0 0 0 32.614 28zm-16.228 0c.228.487.664.861 1.217.995l.3.072.072.306c.122.523.697 1.507 1.906 1.407l.31-.026.16.269c.271.452.726.76 1.232.852l-2.9 2.946a.597.597 0 0 1-.999-.24l-.818-2.492-2.454-.83a.619.619 0 0 1-.236-1.014zm7.425-13.853a.61.61 0 0 1 .795 0l.809.694.983-.41a.61.61 0 0 1 .757.246l.554.91 1.063-.086c.3-.025.574.174.643.467l.247 1.037 1.036.247a.61.61 0 0 1 .468.643l-.086 1.062.91.555a.61.61 0 0 1 .245.756l-.41.984.694.809a.61.61 0 0 1 0 .795l-.694.809.41.984a.61.61 0 0 1-.245.756l-.91.555.086 1.062a.61.61 0 0 1-.468.643l-1.036.247-.247 1.037a.611.611 0 0 1-.643.467l-1.063-.086-.554.91a.61.61 0 0 1-.757.246l-.983-.41-.809.693a.61.61 0 0 1-.795 0l-.809-.694-.984.41a.61.61 0 0 1-.756-.245l-.555-.91-1.062.086A.61.61 0 0 1 19 28.95l-.246-1.037-1.037-.247a.61.61 0 0 1-.467-.643l.086-1.062-.91-.555a.61.61 0 0 1-.246-.756l.41-.984-.694-.809a.61.61 0 0 1 0-.795l.694-.81-.41-.983a.61.61 0 0 1 .246-.756l.91-.555-.086-1.062a.61.61 0 0 1 .467-.643l1.037-.247.246-1.037a.61.61 0 0 1 .644-.467l1.062.086.555-.91a.61.61 0 0 1 .756-.246l.984.41zm3.557 4.722a.61.61 0 0 0-.863 0l-2.95 2.95-1.316-1.315a.61.61 0 0 0-.864 0l-1.85 1.85a.61.61 0 0 0 0 .863l3.598 3.597a.61.61 0 0 0 .863 0l5.232-5.232a.61.61 0 0 0 0-.863zm-.34 1.548.972.967-4.306 4.283L21 22.987l.972-.967 1.297 1.29a.604.604 0 0 0 .85 0l2.909-2.893z"
                fill="#fff"
                fill-rule="nonzero"
              />
            </svg>
          ),
        },
        {
          title: texts.replace,
          color: "#5b32d9",
          route: "/replace-rug",
          svg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="M16 20.64v-.52c0-.43.357-.78.797-.78H28.75v-1.56c0-.694.86-1.04 1.36-.55l2.657 2.599a.768.768 0 0 1 0 1.103l-2.657 2.6c-.498.487-1.36.145-1.36-.552v-1.56H16.797a.789.789 0 0 1-.797-.78zm16.203 4.94H20.25v-1.56c0-.693-.859-1.042-1.36-.551l-2.657 2.6a.768.768 0 0 0 0 1.102l2.657 2.6c.499.488 1.36.145 1.36-.552v-1.56h11.953c.44 0 .797-.349.797-.78v-.52c0-.43-.357-.78-.797-.78z"
                fill="#5b32d9"
                fill-rule="nonzero"
              />
            </svg>
          ),
          activeSvg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <path
                d="M16 20.64v-.52c0-.43.357-.78.797-.78H28.75v-1.56c0-.694.86-1.04 1.36-.55l2.657 2.599a.768.768 0 0 1 0 1.103l-2.657 2.6c-.498.487-1.36.145-1.36-.552v-1.56H16.797a.789.789 0 0 1-.797-.78zm16.203 4.94H20.25v-1.56c0-.693-.859-1.042-1.36-.551l-2.657 2.6a.768.768 0 0 0 0 1.102l2.657 2.6c.499.488 1.36.145 1.36-.552v-1.56h11.953c.44 0 .797-.349.797-.78v-.52c0-.43-.357-.78-.797-.78z"
                fill="#fff"
                fill-rule="nonzero"
              />
            </svg>
          ),
        },
        {
          title: texts.secondhand,
          color: "#5b32d9",
          link: "https://shop.ghalichin.com/stock/",
          svg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <g fill="none" fill-rule="evenodd">
                <path d="M12 12h24v24H12z" />
                <path
                  d="M31.375 27.103a8.001 8.001 0 0 0-11.345-10.05l-.992-1.737A9.996 9.996 0 0 1 29 15.34c4.49 2.592 6.21 8.142 4.117 12.77l1.342.774-4.165 2.214-.165-4.714 1.246.719zm-14.75-6.206a8.001 8.001 0 0 0 11.345 10.05l.992 1.737A9.996 9.996 0 0 1 19 32.66c-4.49-2.592-6.21-8.142-4.117-12.77l-1.343-.773 4.165-2.214.165 4.714-1.246-.719.001-.001z"
                  fill="#5b32d9"
                  fill-rule="nonzero"
                />
                <g fill="#5b32d9" fill-rule="nonzero">
                  <path d="M29 27v1h-1.072a.514.514 0 0 1-.528-.5c0-.276.236-.5.528-.5H29zm-2.127-6.5c0 .369.214.688.527.86v5.28a.989.989 0 0 0-.527.86h-4.648c.253-.266.412-.614.412-1h1.972l1.21-1.146v-2.708l-1.21-1.146h-1.972V21c0-.176-.038-.343-.097-.5zm-5.818 5c.582 0 1.054.448 1.054 1s-.472 1-1.054 1c-.583 0-1.055-.448-1.055-1s.472-1 1.055-1zm5.027.396-.373.354.373.354.373-.354-.373-.354zM24.391 22l.9.854v2.292l-.9.854h-1.754v-.518c.087.01.175.018.263.018 1.018 0 1.864-.673 1.864-1.5s-.846-1.5-1.864-1.5c-.088 0-.176.007-.263.018V22h1.754zm-3.336-2c.582 0 1.054.448 1.054 1v4.39a1.618 1.618 0 0 0-2.109 0V21c0-.552.472-1 1.055-1zm1.845 3c.727 0 1.336.449 1.336 1 0 .551-.609 1-1.336 1-.089 0-.177-.009-.263-.022v-1.956c.086-.013.174-.022.263-.022zm3.182-1.604-.373.354.373.354.373-.354-.373-.354zM29 20v1h-1.072a.514.514 0 0 1-.528-.5c0-.276.236-.5.528-.5H29z" />
                </g>
              </g>
            </svg>
          ),
          activeSvg: (
            <svg
              width="48"
              height="48"
              xmlns="http://www.w3.org/2000/svg"
              style={{ margin: 0 }}
            >
              <g fill="none" fill-rule="evenodd">
                <path d="M12 12h24v24H12z" />
                <path
                  d="M31.375 27.103a8.001 8.001 0 0 0-11.345-10.05l-.992-1.737A9.996 9.996 0 0 1 29 15.34c4.49 2.592 6.21 8.142 4.117 12.77l1.342.774-4.165 2.214-.165-4.714 1.246.719zm-14.75-6.206a8.001 8.001 0 0 0 11.345 10.05l.992 1.737A9.996 9.996 0 0 1 19 32.66c-4.49-2.592-6.21-8.142-4.117-12.77l-1.343-.773 4.165-2.214.165 4.714-1.246-.719.001-.001z"
                  fill="#fff"
                  fill-rule="nonzero"
                />
                <g fill="#fff" fill-rule="nonzero">
                  <path d="M29 27v1h-1.072a.514.514 0 0 1-.528-.5c0-.276.236-.5.528-.5H29zm-2.127-6.5c0 .369.214.688.527.86v5.28a.989.989 0 0 0-.527.86h-4.648c.253-.266.412-.614.412-1h1.972l1.21-1.146v-2.708l-1.21-1.146h-1.972V21c0-.176-.038-.343-.097-.5zm-5.818 5c.582 0 1.054.448 1.054 1s-.472 1-1.054 1c-.583 0-1.055-.448-1.055-1s.472-1 1.055-1zm5.027.396-.373.354.373.354.373-.354-.373-.354zM24.391 22l.9.854v2.292l-.9.854h-1.754v-.518c.087.01.175.018.263.018 1.018 0 1.864-.673 1.864-1.5s-.846-1.5-1.864-1.5c-.088 0-.176.007-.263.018V22h1.754zm-3.336-2c.582 0 1.054.448 1.054 1v4.39a1.618 1.618 0 0 0-2.109 0V21c0-.552.472-1 1.055-1zm1.845 3c.727 0 1.336.449 1.336 1 0 .551-.609 1-1.336 1-.089 0-.177-.009-.263-.022v-1.956c.086-.013.174-.022.263-.022zm3.182-1.604-.373.354.373.354.373-.354-.373-.354zM29 20v1h-1.072a.514.514 0 0 1-.528-.5c0-.276.236-.5.528-.5H29z" />
                </g>
              </g>
            </svg>
          ),
        },
      ],
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="36"
          height="41"
          viewBox="0 0 36 41"
        >
          <g fill="none" fill-rule="evenodd">
            <g fill="#FFF">
              <g>
                <path
                  d="M4.51 12.954c1.974 0 3.647 1.274 4.26 3.046h.498c.613-1.772 2.285-3.046 4.258-3.046 1.977 0 3.65 1.274 4.262 3.046h.327c.61-1.772 2.281-3.046 4.258-3.046 1.974 0 3.646 1.274 4.258 3.046h.5c.612-1.772 2.287-3.046 4.258-3.046 1.976 0 3.649 1.274 4.258 3.046H36c0-8.835-8.056-16-17.998-16C8.059 0 0 7.165 0 16h.253c.609-1.772 2.281-3.046 4.258-3.046zM7 17.455c.436.23.83.53 1.168.883v21.506h20.664V18.359c.337-.357.731-.66 1.168-.893v22.912c-.048.659-.71.599-.71.599-.08.017-.08.017-.164.023H7.584c-.454-.032-.553-.154-.584-.578V17.455zM13.165 17l-.99 1.17v12.128l4.723 5.581h3.17l4.758-5.621V18.144l-.968-1.143c.807.15 1.539.51 2.136 1.021v18.435c-.032.45-.156.548-.584.578H11.59c-.453-.032-.553-.154-.584-.578V18.038c.602-.52 1.342-.886 2.159-1.038zm-.968 18.88h3.177l-3.177-3.755v3.754zm9.423-.034h3.177v-3.754l-3.177 3.754zm-5.265-18.287c.34.201.653.445.929.724l-3.344 5.935 4.56 8.091 4.56-8.091-3.337-5.922c.275-.28.587-.526.927-.728l3.59 6.368c.133.273.126.307 0 .563l-5.23 9.279c-.234.366-.783.37-1.02 0l-5.23-9.279c-.133-.272-.125-.306 0-.563l3.595-6.377z"
                  transform="translate(-276 -760) translate(276 760)"
                />
              </g>
            </g>
          </g>
        </svg>
      ),
      img: "./static/img/bime-icon.png",
      // img: "./static/img/kharid-icon.png",
      boldText: texts.insuranceBoldText,
      lightText: texts.insuranceLightText,
      description: texts.insuranceEndText,
      gif: "./static/gifs/05-bime.gif",
      cardText: texts.fifth_step,
      video:
        "https://www.aparat.com/video/video/embed/videohash/H8aKl/vt/frame",
    },
  ];
  const [sectionData, setSectionData] = useState();
  const [activeSection, setActiveSection] = useState({ title: undefined });
  const [activeTab, setActiveTab] = useState(0);
  const [beforeTab, setBeforeTab] = useState(0);
  const [contactUs, setContactUs] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [openSwitchLang, setOpenSwitchLang] = useState(false);
  const [activeLang, setActiveLang] = useState({});
  const [langFlag, setLangFlag] = useState(false);
  const [video, setVideo] = useState("");
  const languagesList = [
    {
      abbreviation: "FA",
      title: "Persian",
      key: "fa",
    },
    {
      abbreviation: "EN",
      title: "English",
      key: "en",
    },
    {
      abbreviation: "AR",
      title: "Arabic",
      key: "ar",
    },
    {
      abbreviation: "DU",
      title: "German",
      key: "du",
    },
  ];
  useEffect(() => {
    window.scrollTo(0, 0);
    setActiveLang(
      languagesList?.filter((item) => item?.key === globalState.language)[0]
    );
  }, []);

  const myAnimation = (index, beforeIndex, section, flag) => {
    if (flag) {
      document.getElementById("movingContainer").style.background =
        "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%)";
      document.getElementById("movingContainer").style.transition = "all 1s";
      setContactUs(true);
      setActiveSection(section);
      setBeforeTab(0);
      setActiveTab(0);
    } else {
      setContactUs(false);
      var itemWidth =
        ((document?.getElementById("sliderBottomIconsBefore")?.offsetWidth -
          100) /
          5) *
        1;
      if (index > 0) {
        if (window.innerWidth > 550) {
          document.getElementById("movingContainer").style.transform =
            globalState.themeDirection === "ltr"
              ? `translateX(${+itemWidth * (index - 2) + 0.2 * itemWidth}px)`
              : `translateX(${-itemWidth * (index - 2) - 0.2 * itemWidth}px)`;

          document.getElementById("movingContainer").style.background = `${sectionsData[index - 1].iconGradiant
            }`;
          document.getElementById("movingContainer").style.transition =
            "all 0.5s";
        } else {
          var itemWidth =
            ((document?.getElementById("sliderBottomIconsBefore")?.offsetWidth -
              10) /
              5) *
            1;
          document.getElementById("movingContainer").style.transform =
            globalState.themeDirection === "ltr"
              ? `translateX(${+itemWidth * (index - 2)}px)`
              : `translateX(${-itemWidth * (index - 2)}px)`;

          document.getElementById("movingContainer").style.background = `${sectionsData[index - 1].iconGradiant
            }`;
          document.getElementById("movingContainer").style.transition =
            "all 0.5s";
        }
      } else if (index === 0) {
        document.getElementById("movingContainer").style.transform =
          globalState.themeDirection === "ltr"
            ? `translateX(${+itemWidth * (index - 1)}px)`
            : `translateX(${-itemWidth * (index - 1)}px)`;
        document.getElementById("movingContainer").style.background =
          "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%)";
        document.getElementById("movingContainer").style.transition = "all 1s";
      }
      setActiveSection(section);
      setBeforeTab(beforeIndex);
      setActiveTab(index - 1 >= 0 ? index - 1 : 0);
      if (section.title) {
        history.push(`/?type=${section.name}`);
      } else {
        history.push("/");
      }
    }
  };
  function Outside(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          ref.current &&
          openSwitchLang &&
          !ref.current.contains(event.target)
        ) {
          setOpenSwitchLang(false);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, openSwitchLang]);
  }

  useEffect(() => {
    let activeSectionName = history.location.search?.split("=")[1];
    let data_section = sectionsData
      .slice(1, 6)
      .find((sec) => sec.name === activeSectionName);
    if (data_section?.title) {
      myAnimation(data_section?.id, data_section?.id - 2, data_section, false);
    } else {
      // myAnimation(0, activeTab, { title: undefined }, false);
    }
  }, [globalState.language]);
  const wrapperRef2 = useRef(null);
  Outside(wrapperRef2);
  useEffect(() => {
    loadDecorations();
  }, []);
  const loadDecorations = () => {
    getLandingInfo()
      .then((res) => {
        setSectionData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (activeTab) {
      setVideo(sectionsData[activeTab]?.video);
    }
  }, [activeTab]);

  return (
    <div className="landingContainer">
      <div className="landingMainContent activeState">
        <div className="fadeBackground">
          <div className="contentContainer">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                height: "100%",
                width: "100%",
                position: "relative",
              }}
            >
              <div className={"landingHeader"} style={{ position: "relative" }}>
                <SlidingMenu
                  langHandler={langHandler}
                  setActiveLang={setActiveLang}
                  languagesList={languagesList}
                  globalState={globalState}
                  myAnimation={myAnimation}
                  activeTab={activeTab}
                  open={openMenu}
                  onClose={() => setOpenMenu(false)}
                  langFlag={langFlag}
                />

                <span
                  onClick={() => {
                    setOpenMenu(true);
                    setLangFlag(false);
                  }}
                  className={"menuIcon"}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="13"
                    viewBox="0 0 19 13"
                  >
                    <g
                      stroke="#fff"
                      id="prefix__iconfinder_menu_2561466"
                      transform="translate(1 1)"
                    >
                      <path
                        id="prefix__Line_122"
                        d="M0 0L17 0"
                        class="prefix__cls-1"
                        data-name="Line 122"
                        transform="translate(0 5)"
                      />
                      <path
                        id="prefix__Line_123"
                        d="M0 0L17 0"
                        class="prefix__cls-1"
                        data-name="Line 123"
                      />
                      <path
                        id="prefix__Line_124"
                        d="M0 0L17 0"
                        class="prefix__cls-1"
                        data-name="Line 124"
                        transform="translate(0 11)"
                      />
                    </g>
                  </svg>
                </span>

                <span
                  className={"landingHeaderLinks"}
                  style={{
                    flex: 1,
                    display:
                      globalState?.themeDirection === "ltr" ? "flex" : "",
                  }}
                >
                  <span
                    onClick={() => {
                      myAnimation(0, activeTab, { title: undefined }, false);
                    }}
                    style={{
                      textDecoration: "none",
                      color: "#fff",
                      cursor: "pointer",
                      fontWeight: contactUs ? 300 : 800,
                      marginLeft:
                        globalState?.themeDirection === "ltr" ? "0px" : "30px",
                      marginRight:
                        globalState?.themeDirection === "ltr" ? "0px" : "",
                    }}
                  >
                    {activeLang.abbreviation === "FA"
                      ? " صفحه اول  "
                      : texts.home}
                  </span>
                </span>
                <img
                  className="headerLogoIcon"
                  onClick={() => {
                    myAnimation(0, activeTab, { title: undefined }, false);
                  }}
                  width={100}
                  height={57}
                  src="./static/img/ghalichin-logo.svg"
                />

                <div
                  className={"landingHeaderLinks"}
                  style={{
                    flex: 1,
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <span
                    style={{
                      borderRadius: "50%",
                      height: "24px",
                      width: "24px",
                      backgroundColor: "#fff",
                      display: contactUs ? "none" : "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => setOpenSwitchLang(true)}
                    className="headerSwitchLang"
                  >
                    <span
                      style={{
                        color: "#5e6777",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      {activeLang?.abbreviation}
                    </span>
                  </span>
                  {openSwitchLang && (
                    <div
                      ref={wrapperRef2}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        transition: "height 0.5s",
                        height: openSwitchLang ? `${4 * 45}px` : "0px",
                        borderRadius: "4px",
                        position: "absolute",
                        top: "45px",
                        left: "0px",
                        zIndex: 1000,
                        backgroundColor: "#fff",
                        boxShadow: openSwitchLang
                          ? "0 0 35px 0 rgba(34, 53, 132, 0.1)"
                          : "",
                        border: openSwitchLang
                          ? "1px solid rgba(34, 53, 132, 0.1)"
                          : "",
                        maxHeight: "300px",
                        overflow: 4 > 6 ? "scroll" : "",
                        padding: "0px 20px",
                      }}
                    >
                      {languagesList?.map((lang, index) => (
                        <span
                          onClick={() => {
                            setTimeout(() => {
                              setOpenSwitchLang(false);
                            }, 100);
                            setActiveLang(lang);
                            langHandler(lang.key);
                          }}
                          className="langRowContainer  switchLangModal"
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            width: "100%",
                            padding: "0px 10px",
                            borderBottom:
                              index !== 3 ? "1px solid #d3d3d3" : "",
                            height: "45px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "12px",
                            }}
                          >
                            {lang?.title}
                          </span>
                          <span
                            style={{
                              fontSize: "14px",
                              paddingRight:
                                globalState.themeDirection === "ltr"
                                  ? "0px"
                                  : "25px",
                              paddingLeft:
                                globalState.themeDirection === "ltr"
                                  ? "25px"
                                  : "0px",
                              fontWeight: 700,
                            }}
                          >
                            {lang?.abbreviation}
                          </span>
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                <span
                  onClick={() => {
                    setOpenMenu(true);
                    setLangFlag(true);
                  }}
                  className={"langIcon"}
                >
                  <span
                    style={{
                      height: "28px",
                      width: "28px",
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      color: "#5e6777",
                      fontSize: "14px",
                      fontWeight: "bold",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {activeLang?.abbreviation}
                  </span>
                </span>
              </div>
              <div className="SwipeableContainer">
                {contactUs ? (
                  <div className="swipeableContact">
                    <div className={"mapContainer"}>
                      <div
                        className={
                          globalState.themeDirection === "ltr"
                            ? "contactInfoLtr"
                            : "contactInfo"
                        }
                      >
                        <div
                          className="contactInfoRows"
                          style={{
                            marginBottom: "20px",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="13"
                            viewBox="0 0 15 13"
                          >
                            <g fill="none" fill-rule="evenodd">
                              <g fill="#C3C6E1" fill-rule="nonzero">
                                <path
                                  d="M1181.139 335c.2 0 .361.162.361.361v12.278c0 .2-.162.361-.361.361h-.722c-.2 0-.361-.162-.361-.361V341.5h-2.41c-.12 0-.267-.027-.41-.07-.142-.044-.279-.105-.376-.17l-1.715-1.324c-.097-.067-.145-.154-.145-.242s.048-.176.145-.242l1.715-1.321c.097-.067.234-.127.377-.17.142-.045.29-.072.41-.072h2.409v-2.528c0-.2.161-.361.36-.361zm5.66 1.444c.118 0 .266.027.409.071.142.044.278.104.376.171l1.715 1.322c.097.067.145.154.145.242s-.048.175-.145.241l-1.716 1.323c-.097.066-.234.127-.376.17-.142.045-.29.072-.409.072h-4.358l-.579-3.612z"
                                  transform="translate(-1175 -335)"
                                />
                              </g>
                            </g>
                          </svg>
                          <div className="contactInfoTop">
                            <span className="infoTopTitle">
                              {texts.address}
                              {"    : "}
                            </span>
                            <span
                              className="infoRowContent"
                              style={{
                                color: "#727d93",
                              }}
                            >
                              {
                                "میدان ولیعصر - خیابان ولیعصر - کوچه نور بخش - ساختمان نوربخش - پلاک ۴ - رویای کمال"
                              }
                            </span>
                          </div>
                        </div>
                        <div className="contactInfoRows">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="13"
                            viewBox="0 0 13 13"
                          >
                            <g fill="none" fill-rule="evenodd">
                              <g fill="#C3C6E1" fill-rule="nonzero">
                                <path
                                  d="M1178.385 457c.523 0 .948.425.948.948 0 .654.167 1.491.496 2.488.109.345.018.714-.235.967l-1.285 1.333c.899 1.7 1.991 2.788 3.71 3.697l1.49-1.06c.201-.208.608-.311.936-.198.685.226 1.782.492 2.607.492.523 0 .948.425.948.948v2.437c0 .523-.425.948-.948.948-6.533 0-12.052-5.519-12.052-12.052 0-.523.425-.948.948-.948zm4.675 0c3.412 0 4.94 2.48 4.94 4.94 0 .144-.116.26-.26.26-.144 0-.26-.116-.26-.26 0-2.2-1.367-4.42-4.42-4.42-.144 0-.26-.116-.26-.26 0-.144.116-.26.26-.26zm0 2.6c1.487 0 2.34.853 2.34 2.34 0 .144-.116.26-.26.26-.144 0-.26-.116-.26-.26 0-.83-.316-1.82-1.82-1.82-.144 0-.26-.116-.26-.26 0-.144.116-.26.26-.26z"
                                  transform="translate(-1175 -457)"
                                />
                              </g>
                            </g>
                          </svg>
                          <div
                            className="contactInfoTop"
                            style={{
                              position: "relative",
                            }}
                          >
                            <span className="infoTopTitle">
                              {" "}
                              {texts.phoneNumber}
                              {" :"}
                            </span>
                            <span
                              className="infoRowContent"
                              style={{
                                color: "#727d93",
                              }}
                            >
                              {"021-88809006"}
                            </span>

                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href="https://trustseal.enamad.ir/?id=156356&amp;code=5UDVGaiUaXbzCtNYFHDL"
                              style={{
                                height: "60px",
                                width: "50px",
                                position: "absolute",
                                left:
                                  globalState.themeDirection === "ltr" ? "" : 0,
                                right:
                                  globalState.themeDirection === "ltr" ? 0 : "",
                                bottom: 0,
                                cursor: "pointer",
                                border: "1px solid rgba(200,200,200,0.3)",
                                borderRadius: "8px",
                              }}
                            >
                              <img
                                alt="enamed"
                                src="./static/img/namad-2.png"
                                style={{ height: "100%", width: "100%" }}
                              ></img>
                            </a>

                            <a
                              referrerpolicy="origin"
                              target="_blank"
                              href="https://trustseal.enamad.ir/?id=156356&amp;Code=5UDVGaiUaXbzCtNYFHDL"
                            >
                              <img
                                referrerpolicy="origin"
                                src="https://Trustseal.eNamad.ir/logo.aspx?id=156356&amp;Code=5UDVGaiUaXbzCtNYFHDL"
                                alt=""
                                style="cursor:pointer"
                                id="5UDVGaiUaXbzCtNYFHDL"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          globalState?.themeDirection === "ltr"
                            ? "contactFollowUsLtr"
                            : " contactFollowUs"
                        }
                      >
                        <span className="followText">
                          {"ما را روی نقشه دنبال کنید"}
                        </span>
                        <span
                          style={{
                            display: "flex",
                            margin: "0px",
                            justifyContent: "flex-end",
                            alignItems: "center",
                          }}
                        >
                          <img
                            alt={"Location"}
                            style={{
                              height: "22px",
                              width: "18px",
                              marginLeft:
                                globalState.themeDirection === "ltr" ? "" : 15,
                              marginRight:
                                globalState.themeDirection === "ltr" ? 15 : "",
                            }}
                            src="./static/img/location-icon.png"
                          />
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 32 30"
                          >
                            <g fill="none" fill-rule="evenodd">
                              <g fill="#727D93" fill-rule="nonzero">
                                <path
                                  d="M807 566c7.718 0 14 5.832 14 13 0 4.628-2.626 8.688-6.56 10.992.346.594.56 1.274.56 2.008 0 2.206-1.794 4-4 4s-4-1.794-4-4c-1.426 0-2.756-.034-4.01-.098l.01.098c0 2.206-1.794 4-4 4s-4-1.794-4-4c0-.414.082-.804.198-1.18-4.144-1.122-6.198-3.048-6.198-5.82 0-.552.448-1 1-1 .992 0 1.716-.284 2.214-.864 1.168-1.366.802-3.956.798-3.982C793 571.832 799.28 566 807 566zm0 2c-6.618 0-12 4.934-12 11 .012 0 .51 3.362-1.266 5.436-.662.772-1.526 1.26-2.582 1.46.5 1.412 2.266 2.464 5.172 3.152.71-.644 1.644-1.048 2.676-1.048 1.412 0 2.65.74 3.362 1.85 1.43.088 2.946.15 4.638.15.192 0 .38-.018.572-.026.696-1.176 1.966-1.974 3.428-1.974.716 0 1.378.204 1.958.534 3.604-1.9 6.042-5.458 6.042-9.534 0-6.066-5.382-11-12-11zm4.021 12.78c.124-.538.654-.876 1.196-.756.54.122.88.656.758 1.196-.632 2.814-3.09 4.78-5.975 4.78-2.884 0-5.342-1.964-5.976-4.78-.12-.54.218-1.074.756-1.196.54-.116 1.074.216 1.196.756.426 1.896 2.082 3.22 4.024 3.22 1.944 0 3.597-1.324 4.021-3.22zm-8.016-5.78c.55 0 .995.672.995 1.5s-.446 1.5-.995 1.5c-.55 0-1.005-.672-1.005-1.5s.436-1.5.985-1.5zm8 0c.55 0 .995.672.995 1.5s-.446 1.5-.995 1.5c-.55 0-1.005-.672-1.005-1.5s.436-1.5.985-1.5z"
                                  transform="translate(-789 -566)"
                                />
                              </g>
                            </g>
                          </svg>
                        </span>
                      </div>
                      <MyMap />
                    </div>
                    <div className="responsiveContactInfo">
                      <div
                        className="contactInfoRows"
                        style={{
                          marginBottom: "20px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="13"
                          viewBox="0 0 15 13"
                        >
                          <g fill="none" fill-rule="evenodd">
                            <g fill="#C3C6E1" fill-rule="nonzero">
                              <path
                                d="M1181.139 335c.2 0 .361.162.361.361v12.278c0 .2-.162.361-.361.361h-.722c-.2 0-.361-.162-.361-.361V341.5h-2.41c-.12 0-.267-.027-.41-.07-.142-.044-.279-.105-.376-.17l-1.715-1.324c-.097-.067-.145-.154-.145-.242s.048-.176.145-.242l1.715-1.321c.097-.067.234-.127.377-.17.142-.045.29-.072.41-.072h2.409v-2.528c0-.2.161-.361.36-.361zm5.66 1.444c.118 0 .266.027.409.071.142.044.278.104.376.171l1.715 1.322c.097.067.145.154.145.242s-.048.175-.145.241l-1.716 1.323c-.097.066-.234.127-.376.17-.142.045-.29.072-.409.072h-4.358l-.579-3.612z"
                                transform="translate(-1175 -335)"
                              />
                            </g>
                          </g>
                        </svg>
                        <div className="contactInfoTop">
                          <span className="infoTopTitle">
                            {texts.address}
                            {"    : "}
                          </span>
                          <span className="infoRowContent">
                            {
                              "میدان ولیعصر - خیابان ولیعصر - کوچه نور بخش - ساختمان نوربخش - پلاک ۴ - رویای کمال"
                            }
                          </span>
                        </div>
                      </div>
                      <div
                        className="contactInfoRows"
                        style={{
                          marginBottom: "20px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                        >
                          <g fill="none" fill-rule="evenodd">
                            <g fill="#C3C6E1" fill-rule="nonzero">
                              <path
                                d="M1178.385 457c.523 0 .948.425.948.948 0 .654.167 1.491.496 2.488.109.345.018.714-.235.967l-1.285 1.333c.899 1.7 1.991 2.788 3.71 3.697l1.49-1.06c.201-.208.608-.311.936-.198.685.226 1.782.492 2.607.492.523 0 .948.425.948.948v2.437c0 .523-.425.948-.948.948-6.533 0-12.052-5.519-12.052-12.052 0-.523.425-.948.948-.948zm4.675 0c3.412 0 4.94 2.48 4.94 4.94 0 .144-.116.26-.26.26-.144 0-.26-.116-.26-.26 0-2.2-1.367-4.42-4.42-4.42-.144 0-.26-.116-.26-.26 0-.144.116-.26.26-.26zm0 2.6c1.487 0 2.34.853 2.34 2.34 0 .144-.116.26-.26.26-.144 0-.26-.116-.26-.26 0-.83-.316-1.82-1.82-1.82-.144 0-.26-.116-.26-.26 0-.144.116-.26.26-.26z"
                                transform="translate(-1175 -457)"
                              />
                            </g>
                          </g>
                        </svg>
                        <div
                          className="contactInfoTop"
                          style={{ position: "relative" }}
                        >
                          <span className="infoTopTitle">
                            {texts.phoneNumber}
                            {" :"}
                          </span>
                          <span className="infoRowContent">
                            {"021-88809006"}
                          </span>

                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://trustseal.enamad.ir/?id=156356&amp;code=5UDVGaiUaXbzCtNYFHDL"
                            style={{
                              height: "60px",
                              width: "50px",
                              position: "absolute",
                              // left: 0,
                              bottom: 0,
                              left:
                                globalState.themeDirection === "ltr" ? "" : 0,
                              right:
                                globalState.themeDirection === "ltr" ? 0 : "",
                              cursor: "pointer",
                              // border: "1px solid rgba(200,200,200,0.3)",
                              borderRadius: "8px",
                            }}
                          >
                            <img
                              alt="enamad"
                              src="./static/img/namad-2.png"
                              style={{ height: "100%", width: "100%" }}
                            ></img>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sliderBottomContainer">
        <div
          className="sliderBottomIconsBefore"
          id="sliderBottomIconsBefore"
          style={{
            position: "relative",
            direction: globalState.themeDirection,
          }}
        >
          {sectionsData.slice(1, 6)?.map((section, index) => {
            return (
              <div
                id={`slide${index}`}
                key={section?.title + index}
                onClick={() => {
                  if (section.name === "rugGenerate" || section.Route || section.link) {
                    window.open(section.link || section.Route || "https://rug.ghalichin.com", "_blank");
                  } else {
                    contactUs
                      ? myAnimation(index + 2, activeTab, section, false)
                      : myAnimation(index + 2, activeTab, section, false);
                  }
                }}
                style={{
                  height: "100%",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "15px 0px",
                  cursor: "pointer",
                  zIndex: 10000,
                }}
              >
                <span
                  className="bottomIconsContainer"
                  style={{
                    height: "50px",
                    width: "50px",
                  }}
                >
                  {section.svg}
                </span>
                <span className="bottomtitlesContainer">{section.title}</span>
              </div>
            );
            // }
          })}
          <div
            id="movingContainer"
            style={{
              borderRadius: window.innerWidth <= 550 ? "11px" : "15px",
              height:
                window.innerWidth <= 550
                  ? `${document?.getElementById("sliderBottomIconsBefore")
                    ?.offsetHeight * 0.9
                  }px`
                  : `${document?.getElementById("sliderBottomIconsBefore")
                    ?.offsetHeight * 1.2
                  }px`,
              width:
                window.innerWidth <= 550
                  ? `${(document?.getElementById("sliderBottomIconsBefore")
                    ?.offsetWidth /
                    5) *
                  1
                  }px`
                  : `${((document?.getElementById("sliderBottomIconsBefore")
                    ?.offsetWidth -
                    80) /
                    5) *
                  0.6
                  }px`,
              position: "absolute",
              marginTop: window.innerWidth <= 550 ? 0 : -40,
            }}
          ></div>
        </div>
        <div className="sliderButtons">
          {sectionsData[activeTab].title ? (
            <div className="sliderButtonsItem">
              {sectionsData[activeTab]?.buttons.map((item, index) => {
                return (
                  <button
                    style={{
                      border: "none",
                      backgroundColor:
                        activeBtn == item.title
                          ? item.color
                          : item.color + "0C",
                      color: activeBtn == item.title ? "#fff" : item.color,
                      padding: window.innerWidth < 550 ? 0 : "6px 10px",
                      width: window.innerWidth < 550 ? "100%" : 150,
                      margin: window.innerWidth < 550 ? 0 : 25,
                      marginTop: window.innerWidth < 550 ? 13 : 25,
                      borderRadius: 10,
                      cursor: "pointer",
                      display: "flex",
                      flexDirection: window.innerWidth < 550 ? "row" : "column",
                      alignItems: "center",
                    }}
                    onMouseEnter={() => setActiveBtn(item.title)}
                    onMouseLeave={() => setActiveBtn("")}
                    onClick={() =>
                      item.link
                        ? window.open(`${item.link}`, "_blank")
                        : history.push(item.route)
                    }
                  >
                    {activeBtn == item.title ? item.activeSvg : item.svg}
                    {item.title}
                  </button>
                );
              })}
            </div>
          ) : (
            <div>
              <p
                className="textSlide"
                style={{ color: "#5e6777", textAlign: "center" }}
              >
                {texts.welcome}
              </p>
              <p
                className="textSlide"
                style={{
                  color: "#e08b14",
                  fontSize: 14,
                  marginTop: 26,
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {texts.landing_tab}

                {/* برای معرفی کامل هر بخش از
                <span style={{ color: "#5e6777" }}> منو بالا </span> و همچنین
                برای معرفی جزئی تر هر بخش از{" "}
                <span style={{ color: "#5e6777" }}> منو پایین </span> پایین
                استفاده کنید. */}
              </p>
            </div>
          )}
        </div>
      </div>
      <div className="slidesContainer3">
        {!activeSection.title && (
          <p
            style={{
              color: "#5e6777",
              fontSize: 12,
              margin: "30px 0",
              lineHeight: "23px",
              fontWeight: "bold",
              padding: "0 26px",
              paddingBottom: isMobile ? 0 : 26,
              textAlign: "center",
              display: isMobile ? "block" : "none",
            }}
          >
            {texts.welcome}
          </p>
        )}

        {!activeSection.title ? (
          sectionsData.slice(1, 6).map((section) => {
            return (
              <div
                className="room-cards"
                style={{ direction: globalState.themeDirection }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-betweenx",
                  }}
                >
                  <div
                    className={
                      globalState.themeDirection == "ltr"
                        ? "room-card-right-EN"
                        : "room-card-right"
                    }
                    style={{ direction: globalState.themeDirection }}
                  >
                    <span
                      style={{
                        color: section.color,
                        fontSize: 24,
                        fontWeight: "bold",
                        width: "100%",
                        cursor:
                          section.name === "rugGenerate" ||
                          section.Route ||
                          section.link
                            ? "pointer"
                            : "inherit",
                      }}
                      onClick={() => {
                        if (
                          section.name === "rugGenerate" ||
                          section.Route ||
                          section.link
                        ) {
                          window.open(
                            section.link ||
                              section.Route ||
                              "https://rug.ghalichin.com",
                            "_blank"
                          );
                        }
                      }}
                    >
                      {section.title}
                    </span>
                  </div>
                  <div
                    className={
                      globalState.themeDirection == "ltr"
                        ? "room-card-left-EN"
                        : "room-card-left"
                    }
                    style={{ direction: globalState.themeDirection }}
                  >
                    {section.buttons.map((item, index) => {
                      return (
                        <button
                          style={{
                            border: "none",
                            backgroundColor:
                              activeBtn == item.title
                                ? item.color
                                : item.color + "0C",
                            color:
                              activeBtn == item.title ? "#fff" : item.color,
                            padding: "0",
                            borderRadius: 10,
                            cursor: "pointer",
                            display: "flex",
                            justifyContent:
                              globalState.themeDirection == "ltr"
                                ? "left"
                                : "right",
                            height: 48,
                            alignItems: "center",
                          }}
                          onMouseEnter={() => setActiveBtn(item.title)}
                          onMouseLeave={() => setActiveBtn("")}
                          onClick={() =>
                            item.link
                              ? (window.location.href = item.link)
                              : history.push(item.route)
                          }
                        >
                          {activeBtn == item.title ? item.activeSvg : item.svg}
                          <span style={{ margin: 0 }}>{item.title}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
                <p
                  style={{
                    color: isMobile ? "#5e6777" : "#bbc2ce",
                    marginTop: "20px",
                    fontSize: isMobile ? 10 : 14,
                    lineHeight: isMobile ? "18px" : "20px",
                  }}
                >
                  {section.cardText}
                </p>
              </div>
            );
          })
        ) : (
          <div>
            {" "}
            <div className="room-description">
              <p style={{ width: window.innerWidth < 550 ? "100%" : 425 }}>
                <strong className="slidesStrongContent">
                  {sectionsData[activeTab]?.boldText}
                </strong>
                <span className="slidesLightContent">
                  {sectionsData[activeTab]?.lightText}
                </span>
              </p>

              <div
                style={{
                  backgroundImage:
                    "url(" +
                    `${sectionsData[activeTab].gif}` +
                    "),url('./static/svg/rectangle.svg')",
                  backgroundSize: "contain",
                  backgroundPosition: "center center",
                  backgroundRepeat: "no-repeat no-repeat",
                  height: 400,

                  width: window.innerWidth < 550 ? "100%" : "50%",
                }}
              ></div>
            </div>
            {video && (
              <div
                className="my-4"
                dangerouslySetInnerHTML={{
                  __html: `<style>.h_iframe-aparat_embed_frame{position:relative;}.h_iframe-aparat_embed_frame .ratio{display:block;width:100%;height:auto;}.h_iframe-aparat_embed_frame iframe{position:absolute;top:0;left:0;width:100%;height:100%;}</style><div class="h_iframe-aparat_embed_frame"><span style="display: block;padding-top: 57%"></span><iframe src=${video} allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe></div>`,
                }}
              ></div>
            )}
            <div
              style={{
                backgroundColor: "#bbc2ce19",
                borderRadius: 15,
                padding: 27,
                color: "#5e6777",
                fontSize: 14,
                lineHeight: 1.93,
                letterSpacing: "0.95px",
                fontWeight: "bold",
                marginBottom: 20,
              }}
            >
              <p
                className="my-4"
                dangerouslySetInnerHTML={{
                  __html: sectionsData[activeTab]?.description,
                }}
              ></p>
            </div>
          </div>
        )}
      </div>
      <div
        className="room-cards footer-card d-flex"
      // style={{ maxWidth: 934, position: "absolute", bottom: 65 }}
      >
        <div
          style={{
            height: "100%",
            width: isMobile ? "100%" : "50%",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: isMobile ? "start" : "center",
          }}
        >
          {isMobile ? (
            <>
              <svg
                width="100"
                style={{ transform: "scale(0.7)", margin: 0, marginRight: -10 }}
                height="37"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.901 32c.594 0 1.07.226 1.427.679.357.452.536 1.056.536 1.811 0 .77-.179 1.381-.536 1.833-.358.451-.842.677-1.452.677a1.69 1.69 0 0 1-1.405-.687c-.355-.458-.532-1.063-.532-1.816 0-.757.178-1.363.534-1.817.357-.453.833-.68 1.428-.68zm-9.63.119c.402 0 .71.1.925.302.215.202.322.495.322.879 0 .635-.282 1.085-.848 1.351l1.401 2.23H2.34l-1.194-2.014H.59v1.345c0 .336-.218.614-.503.662L0 36.88v-4.762h1.27zm48.068 0v.505h-1.75v1.528h1.467v.5H47.59v1.724h1.426c.219 0 .4.179.438.414l.007.09h-2.467V32.12h2.345zm45.772 0v4.257h1.444c.118 0 .231.053.314.148a.529.529 0 0 1 .122.258l.009.099h-2.484v-4.762h.595zm-36.6 0-1.645 2.272 1.937 2.49h-.754l-1.835-2.413v2.413h-.559v-4.762c.148 0 .29.067.395.186a.68.68 0 0 1 .164.448v1.708l1.699-2.342h.598zm-36.297 0-1.5 2.76v2.002h-.596v-1.988l-1.4-2.774c.42 0 .81.255 1.019.67l.132.26.137.27.48.95 1.175-2.15h.553zm18.652 0-1.5 2.76v2.002h-.596v-1.988l-1.4-2.774c.42 0 .809.255 1.019.67l.132.26.137.27.48.95 1.175-2.15h.553zm-10.763 0 1.64 4.762h-.644l-.457-1.32h-1.778l-.184.525-.074.212c-.11.313-.359.53-.647.575l-.11.008 1.665-4.762h.59zm36.618 0 1.64 4.762h-.645l-.456-1.32h-1.778l-.184.525-.074.212c-.11.313-.36.53-.648.575l-.11.008 1.665-4.762h.59zm20.035 0 1.64 4.762h-.644l-.456-1.32h-1.779l-.183.525-.074.212c-.11.313-.36.53-.648.575l-.11.008 1.665-4.762h.59zm-11.45 0 1.162 3.684 1.197-3.684h.737v4.762c-.307 0-.556-.282-.556-.63v-3.244l-1.157 3.555h-.575l-1.124-3.565v3.305a.62.62 0 0 1-.15.41.481.481 0 0 1-.36.169v-4.762h.825zm-64.405.386c-.418 0-.744.175-.978.526-.235.35-.352.838-.352 1.463 0 .622.117 1.11.35 1.467.232.356.553.534.963.534.43 0 .761-.176.996-.526.234-.35.351-.846.351-1.485 0-.62-.117-1.105-.353-1.454a1.115 1.115 0 0 0-.977-.525zm18.854.502-.718 2.053h1.432l-.714-2.053zm36.617 0-.717 2.053h1.432l-.715-2.053zm20.036 0-.718 2.053h1.433l-.715-2.053zM.964 32.624H.59v1.738h.193c.748 0 1.123-.334 1.123-1.001 0-.491-.314-.737-.942-.737zM17.376.186v20.707c0 2.211 1.702 4.024 3.852 4.17 2.15-.146 3.852-1.959 3.852-4.17V14.81h5.427c2.28 0 4.13 1.872 4.13 4.178v6.082h4.43V12.977c0-2.306-1.85-4.179-4.13-4.179h-6.553V4.364c0-2.306 1.85-4.178 4.13-4.178h16.258v.928H35.819c-2.28 0-4.13 1.873-4.13 4.179V7.87h6.552c2.28 0 4.13 1.872 4.13 4.178V26H18.203c-2.28 0-4.13-1.872-4.13-4.179V.186h3.304zm45.703 0v.928H59.5c-2.279 0-4.13 1.873-4.13 4.179v6.871h3.58c2.28 0 4.13 1.873 4.13 4.179V26H49.592c-2.28 0-4.13-1.872-4.13-4.179V4.271h3.304v16.622c0 2.306 1.85 4.178 4.13 4.178h6.88v-7.8c0-2.306-1.851-4.178-4.131-4.178h-3.58V4.364c0-2.306 1.85-4.178 4.13-4.178h6.884zM97 .07v21.635c0 2.306-1.85 4.179-4.13 4.179H78.688v-.929h10.877c2.28 0 4.13-1.872 4.13-4.178V.07H97zM76.97 23.362v2.522H66.405v-2.522h10.563zM10.825 0v21.636c0 2.306-1.851 4.178-4.13 4.178H0v-.928h3.391c2.28 0 4.13-1.873 4.13-4.179V0h3.305zm17.558 15.913v5.908a4.19 4.19 0 0 1-1.536 3.25h4.485v-5.153a4.177 4.177 0 0 0-2.95-4.005zM69.71.186v15.948c0 2.306 1.85 4.178 4.13 4.178h3.13v.93h-6.434c-2.28 0-4.13-1.873-4.13-4.18V.186h3.304zM89.795.07v16.992c0 2.307-1.85 4.18-4.13 4.18h-6.977v-.93h3.672c2.28 0 4.13-1.872 4.13-4.178v-.604h-7.802V4.248c0-2.306 1.851-4.178 4.13-4.178h6.977zm-3.304.928h-.368c-2.28 0-4.13 1.873-4.13 4.179v9.425h4.498V.998z"
                  fill="#D5D5D5"
                  fill-rule="evenodd"
                />
              </svg>
              <svg
                width="130"
                style={{ transform: "scale(0.7)", margin: 0, marginRight: -12 }}
                height="16"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M126.338 2.334a8.606 8.606 0 0 1 2.657 5.925l.005.308V16H90v-.333l.001-.047v-.28l.001-.13v-.293c.005-1.353.011-3.782.018-6.186l.001-.554.005-1.888c.007-2.527 1.959-4.612 4.456-4.76L109.51.64l1.47-.088 9.044-.536a8.427 8.427 0 0 1 6.314 2.32zM48 5v11h-2V5h2zm27 0v11h-2V5h2zM43 0v16h-2V0h2zm40 5c1.575 0 2.8.508 3.684 1.501C87.55 7.475 88 8.823 88 10.556V16h-2.169v-5.444c0-1.118-.232-1.979-.734-2.572-.479-.566-1.182-.834-2.097-.834s-1.618.268-2.097.834c-.502.593-.734 1.454-.734 2.572V16H78v-5.444c0-1.732.445-3.08 1.306-4.054C80.183 5.51 81.41 5 83 5zM33.5 5c1.737 0 3.081.5 4.043 1.468.902.908 1.393 2.143 1.451 3.713L39 10.5v2.227c0 .242-.053.551-.166.927-.119.394-.381.778-.804 1.141-.386.332-.942.623-1.674.86-.7.227-1.651.345-2.856.345-1.205 0-2.157-.118-2.856-.345-.732-.237-1.288-.528-1.674-.86-.423-.363-.685-.747-.804-1.14-.113-.377-.166-.686-.166-.928 0-.84.141-1.498.403-1.98a2.765 2.765 0 0 1 1.112-1.14c.439-.24.956-.397 1.553-.465.414-.048.852-.078 1.313-.09l.47-.006h3.807c-.184-.543-.482-.977-.903-1.297-.556-.423-1.31-.621-2.255-.621-.871 0-1.593.18-2.16.556l-.166.118-.326.253-1.307-1.671.324-.256C30.811 5.382 32.021 5 33.5 5zm28.786-5v5.465a4.95 4.95 0 0 1 .96-.482c.665-.251 1.42-.38 2.264-.38.846 0 1.606.136 2.28.402.688.27 1.27.656 1.746 1.155.472.496.837 1.104 1.091 1.825.248.703.373 1.494.373 2.375V16h-2.286v-5.64c0-1.153-.261-2.042-.824-2.654-.547-.595-1.344-.875-2.38-.875-1.048 0-1.853.28-2.4.875-.562.612-.824 1.5-.824 2.654V16H60V0h2.286zm-7.661 5c1.458 0 2.662.362 3.616 1.068l.336.249L57.27 8.02l-.34-.254c-.58-.434-1.35-.639-2.305-.639-1.13 0-1.996.271-2.584.852-.589.58-.865 1.425-.865 2.52 0 1.106.275 1.953.863 2.528.589.575 1.455.844 2.586.844 1.098 0 1.954-.266 2.554-.83l.305-.288L59 14.296l-.302.287c-.5.475-1.098.832-1.799 1.07-.68.23-1.438.347-2.274.347-1.776 0-3.15-.496-4.134-1.458C49.507 13.58 49 12.237 49 10.5c0-1.723.506-3.064 1.49-4.032C51.474 5.5 52.849 5 54.625 5zM18.286 0v5.465c.293-.19.612-.351.96-.482.665-.251 1.42-.38 2.264-.38.846 0 1.606.136 2.28.402.688.27 1.27.656 1.745 1.155a5.023 5.023 0 0 1 1.092 1.825c.247.703.373 1.494.373 2.375V16h-2.286v-5.64c0-1.153-.262-2.042-.824-2.654-.547-.595-1.345-.875-2.38-.875-1.048 0-1.853.28-2.4.875-.562.612-.824 1.5-.824 2.654V16H16V0h2.286zM7.923 0C9.996 0 11.7.519 13.04 1.537l.35.266-1.35 1.818-.35-.265c-.967-.728-2.224-1.082-3.766-1.082-1.851 0-3.268.472-4.236 1.456-.97.985-1.435 2.412-1.435 4.27 0 1.87.466 3.305 1.435 4.29.968.984 2.385 1.456 4.236 1.456 1.587 0 2.864-.37 3.825-1.135V7.393L14 6.71v6.406c0 .287-.096.554-.298.8l-.016.02-.019.017C12.256 15.309 10.345 16 7.923 16c-1.235 0-2.337-.183-3.304-.543-.986-.367-1.821-.898-2.506-1.59-.686-.692-1.212-1.535-1.575-2.53C.18 10.36 0 9.247 0 8c0-1.234.18-2.342.538-3.326.363-1.003.89-1.849 1.575-2.541.685-.692 1.52-1.223 2.506-1.59C5.586.183 6.688 0 7.923 0zm28.949 11.174H33.5c-.814 0-1.467.021-1.96.064-.433.037-.767.107-.997.225a.581.581 0 0 0-.313.347c-.07.23-.102.535-.102.917 0 .164.067.3.195.414.186.166.432.297.732.4.334.116.711.199 1.132.25a10.732 10.732 0 0 0 2.626 0c.42-.051.798-.134 1.132-.25.3-.103.546-.234.732-.4a.548.548 0 0 0 .187-.319l.008-.095v-1.553zm76.19-6.884c-.707 0-1.339.105-1.893.311a3.918 3.918 0 0 0-1.44.914 3.958 3.958 0 0 0-.904 1.46c-.205.565-.309 1.2-.309 1.908 0 .716.104 1.354.309 1.914.208.573.51 1.057.904 1.455.394.397.873.702 1.44.913.554.207 1.186.312 1.894.312s1.34-.105 1.895-.312a3.918 3.918 0 0 0 1.439-.913c.394-.398.696-.882.905-1.455.204-.56.308-1.198.308-1.914 0-.707-.104-1.343-.308-1.907a3.958 3.958 0 0 0-.905-1.46 3.918 3.918 0 0 0-1.44-.915c-.554-.206-1.186-.311-1.894-.311zm-15.954 0c-1.03 0-1.83.234-2.4.681-.6.469-.904 1.119-.904 1.954 0 .493.105.893.302 1.204.195.309.45.558.764.747.297.178.636.319 1.018.42l.54.137.545.122.255.053c.328.07.608.141.842.212a2.7 2.7 0 0 1 .649.275c.13.081.224.176.277.29.06.126.086.282.086.468 0 .267-.054.483-.177.643-.13.17-.29.302-.48.396-.201.1-.417.164-.647.194a5.259 5.259 0 0 1-.67.049c-.2 0-.423-.017-.671-.049a2.031 2.031 0 0 1-.647-.194 1.318 1.318 0 0 1-.473-.393.936.936 0 0 1-.167-.491l-.006-.155v-.28h-1.34v.28l.006.205c.047.738.349 1.318.898 1.744.572.443 1.37.675 2.4.675 1.029 0 1.828-.232 2.403-.674.604-.465.91-1.114.91-1.95 0-.493-.104-.892-.302-1.2a2.298 2.298 0 0 0-.763-.74 3.922 3.922 0 0 0-1.019-.42l-.54-.136-.544-.122-.25-.053c-.322-.07-.598-.142-.83-.212a2.683 2.683 0 0 1-.648-.28.776.776 0 0 1-.292-.302 1.04 1.04 0 0 1-.089-.463c0-.268.053-.485.173-.645.127-.169.285-.3.473-.394.2-.1.417-.164.647-.194.248-.032.471-.048.67-.048.2 0 .422.016.67.048.231.03.447.095.647.194.19.095.35.227.48.396a.916.916 0 0 1 .171.49l.007.153v.28h1.34v-.28l-.007-.205c-.046-.738-.35-1.32-.903-1.75-.575-.446-1.375-.68-2.404-.68zm25.374.08h-3.614l-.104.007a.653.653 0 0 0-.363.183.635.635 0 0 0-.196.367l-.008.108v8.374h1.34V9.968h2.882l.227-.01c.299-.023.583-.094.853-.211a2.839 2.839 0 0 0 1.478-1.493c.145-.341.219-.705.219-1.091 0-.378-.07-.737-.213-1.077a2.748 2.748 0 0 0-.586-.888 2.832 2.832 0 0 0-.862-.595 2.7 2.7 0 0 0-1.053-.234zm-19.875 0h-1.34v9.04h1.34V9.152h3.948v4.256h1.34V4.37h-1.34V7.8h-3.948V4.37zm10.456 1.274c1.047 0 1.85.265 2.397.822.548.557.81 1.366.81 2.417 0 1.06-.262 1.872-.81 2.429-.548.557-1.35.823-2.397.823-1.047 0-1.849-.266-2.397-.823-.548-.557-.81-1.37-.81-2.429 0-1.051.262-1.86.81-2.417.548-.557 1.35-.822 2.397-.822zm9.356.067c.194 0 .378.038.552.114a1.458 1.458 0 0 1 .773 1.906 1.47 1.47 0 0 1-.773.781c-.13.057-.267.092-.408.106l-.144.007h-2.882V5.711h2.882zM75 0v3h-2V0h2zM48 0v3h-2V0h2z"
                  fill="#D5D5D5"
                  fill-rule="evenodd"
                />
              </svg>
              <svg
                width="125"
                style={{ transform: "scale(0.7)", margin: 0, marginRight: -12 }}
                height="16"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g fill="none" fill-rule="evenodd">
                  <path
                    d="M13.744 13.132V6.879l-2.211.666v5.093c-.943.746-2.197 1.107-3.755 1.107-1.817 0-3.208-.46-4.159-1.421-.951-.961-1.408-2.361-1.408-4.187 0-1.813.457-3.206 1.408-4.167.95-.96 2.342-1.421 4.16-1.421 1.513 0 2.747.345 3.695 1.056l.345.258 1.325-1.774-.343-.26C11.485.835 9.813.33 7.778.33c-1.213 0-2.294.178-3.244.53-.968.359-1.787.877-2.46 1.552S.884 3.913.528 4.891C.178 5.851 0 6.933 0 8.137c0 1.218.177 2.303.528 3.257.357.972.873 1.794 1.546 2.47.673.675 1.492 1.193 2.46 1.551.95.352 2.031.53 3.244.53 2.377 0 4.254-.674 5.64-1.997l.017-.017.016-.019c.199-.24.293-.5.293-.78zM21.143 4.588c-.816 0-1.546.128-2.19.378-.336.13-.645.29-.927.48V0h-2.212v15.945h2.211v-5.62c0-1.15.253-2.035.797-2.645.53-.593 1.308-.872 2.321-.872 1.002 0 1.774.28 2.302.872.544.61.797 1.495.797 2.645v5.62h2.211v-5.62c0-.878-.121-1.667-.36-2.367-.246-.72-.6-1.325-1.057-1.819a4.641 4.641 0 0 0-1.687-1.151c-.652-.265-1.387-.4-2.206-.4zM33.062 4.472c-1.537 0-2.794.399-3.777 1.177l-.336.267 1.357 1.742.339-.263c.613-.477 1.421-.703 2.417-.703.982 0 1.765.207 2.343.647.437.334.748.786.938 1.353h-3.956c-.66 0-1.278.034-1.852.1-.62.071-1.158.235-1.614.486-.482.265-.869.66-1.155 1.19-.272.501-.419 1.188-.419 2.064 0 .252.055.575.173.967.123.41.396.81.835 1.19.401.346.979.65 1.74.896.726.237 1.715.36 2.967.36s2.24-.123 2.968-.36c.76-.247 1.338-.55 1.739-.896.44-.38.712-.78.835-1.19.118-.392.173-.715.173-.967v-2.323c0-1.798-.515-3.196-1.514-4.206-1-1.01-2.396-1.531-4.201-1.531zm3.504 6.44v1.62a.56.56 0 0 1-.203.432c-.194.173-.449.31-.76.418-.348.12-.74.206-1.176.26a11.096 11.096 0 0 1-2.73 0 5.772 5.772 0 0 1-1.175-.26 2.219 2.219 0 0 1-.761-.418.56.56 0 0 1-.203-.432c0-.398.033-.718.106-.957a.606.606 0 0 1 .325-.362c.24-.123.586-.196 1.037-.235.511-.044 1.19-.066 2.036-.066h3.504zM40.79 15.945H43V0h-2.21zM45.591 15.945h2.212V4.782H45.59v11.163zm2.212-13.26V0H45.59v2.684h2.212zM58.954 14.468l.307-.3-1.54-1.609-.31.3c-.61.59-1.479.867-2.595.867-1.149 0-2.029-.28-2.627-.88-.597-.6-.876-1.484-.876-2.637 0-1.143.28-2.023.878-2.63.597-.604 1.477-.887 2.625-.887.97 0 1.753.214 2.342.666l.346.265 1.328-1.778-.342-.26c-.97-.736-2.192-1.113-3.674-1.113-1.805 0-3.201.52-4.2 1.531-1 1.01-1.514 2.408-1.514 4.206 0 1.811.515 3.213 1.514 4.216 1 1.003 2.396 1.52 4.2 1.52.85 0 1.62-.122 2.31-.362a4.863 4.863 0 0 0 1.828-1.115zM65.54 4.588c-.817 0-1.547.128-2.19.378-.337.13-.646.29-.928.48V0H60.21v15.945h2.211v-5.62c0-1.15.253-2.035.797-2.645.53-.593 1.308-.872 2.321-.872 1.002 0 1.773.28 2.302.872.544.61.797 1.495.797 2.645v5.62h2.211v-5.62c0-.878-.122-1.667-.36-2.367-.247-.72-.6-1.325-1.057-1.819a4.641 4.641 0 0 0-1.687-1.151c-.652-.265-1.387-.4-2.206-.4zM72.939 15.945h2.21V4.782h-2.21v11.163zm2.21-13.26V0h-2.21v2.684h2.21zM85.243 15.945h2.211v-5.62c0-1.79-.458-3.182-1.342-4.187-.901-1.025-2.15-1.55-3.756-1.55-1.62 0-2.872.526-3.766 1.551-.877 1.005-1.331 2.397-1.331 4.186v5.62h2.21v-5.62c0-1.155.238-2.043.749-2.655.488-.586 1.206-.862 2.138-.862.933 0 1.65.276 2.139.862.511.612.748 1.5.748 2.655v5.62zM126 6.62a6.47 6.47 0 0 0-2.03-4.71 6.42 6.42 0 0 0-4.81-1.737l-29.034 1.84L90.088 16H126V6.62z"
                    fill="#D5D5D5"
                  />
                  <path
                    d="M123.22 12.411V8.265l-1.574.474v3.317c-.596.46-1.385.681-2.36.681-1.155 0-2.04-.29-2.644-.9-.605-.61-.891-1.5-.891-2.66 0-1.153.287-2.04.891-2.65.604-.61 1.489-.9 2.644-.9.962 0 1.747.218 2.35.67l.28.21.944-1.262-.28-.211c-.862-.652-1.96-.986-3.294-.986-.795 0-1.504.117-2.126.348a4.412 4.412 0 0 0-1.62 1.021 4.424 4.424 0 0 0-1.017 1.632c-.23.63-.346 1.338-.346 2.127 0 .798.117 1.509.346 2.134.235.64.575 1.18 1.018 1.625.443.444.982.786 1.619 1.022.622.23 1.33.347 2.126.347 1.56 0 2.79-.445 3.7-1.313l.015-.014.013-.015a.843.843 0 0 0 .206-.551zM93.423 4.09a.761.761 0 0 0-.406.27.772.772 0 0 0-.149.478v9.39h1.574V7.666l2.764 4.594c.165.256.39.378.67.378a.794.794 0 0 0 .671-.378l2.777-4.598v6.568h1.574V4.838a.789.789 0 0 0-.57-.749.7.7 0 0 0-.512.016.774.774 0 0 0-.38.327l-3.559 5.896-3.548-5.897a.77.77 0 0 0-.39-.328.722.722 0 0 0-.516-.013zm17.902 7.606 1.262 2.533h1.74l-4.796-9.735c-.15-.302-.386-.446-.7-.446-.314 0-.55.144-.7.445l-4.77 9.736h1.768l1.212-2.533h4.984zm-.771-1.58h-3.446l1.723-3.496 1.723 3.496z"
                    fill="#FFF"
                  />
                </g>
              </svg>
            </>
          ) : (
            <>
              <svg width="97" height="37" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.901 32c.594 0 1.07.226 1.427.679.357.452.536 1.056.536 1.811 0 .77-.179 1.381-.536 1.833-.358.451-.842.677-1.452.677a1.69 1.69 0 0 1-1.405-.687c-.355-.458-.532-1.063-.532-1.816 0-.757.178-1.363.534-1.817.357-.453.833-.68 1.428-.68zm-9.63.119c.402 0 .71.1.925.302.215.202.322.495.322.879 0 .635-.282 1.085-.848 1.351l1.401 2.23H2.34l-1.194-2.014H.59v1.345c0 .336-.218.614-.503.662L0 36.88v-4.762h1.27zm48.068 0v.505h-1.75v1.528h1.467v.5H47.59v1.724h1.426c.219 0 .4.179.438.414l.007.09h-2.467V32.12h2.345zm45.772 0v4.257h1.444c.118 0 .231.053.314.148a.529.529 0 0 1 .122.258l.009.099h-2.484v-4.762h.595zm-36.6 0-1.645 2.272 1.937 2.49h-.754l-1.835-2.413v2.413h-.559v-4.762c.148 0 .29.067.395.186a.68.68 0 0 1 .164.448v1.708l1.699-2.342h.598zm-36.297 0-1.5 2.76v2.002h-.596v-1.988l-1.4-2.774c.42 0 .81.255 1.019.67l.132.26.137.27.48.95 1.175-2.15h.553zm18.652 0-1.5 2.76v2.002h-.596v-1.988l-1.4-2.774c.42 0 .809.255 1.019.67l.132.26.137.27.48.95 1.175-2.15h.553zm-10.763 0 1.64 4.762h-.644l-.457-1.32h-1.778l-.184.525-.074.212c-.11.313-.359.53-.647.575l-.11.008 1.665-4.762h.59zm36.618 0 1.64 4.762h-.645l-.456-1.32h-1.778l-.184.525-.074.212c-.11.313-.36.53-.648.575l-.11.008 1.665-4.762h.59zm20.035 0 1.64 4.762h-.644l-.456-1.32h-1.779l-.183.525-.074.212c-.11.313-.36.53-.648.575l-.11.008 1.665-4.762h.59zm-11.45 0 1.162 3.684 1.197-3.684h.737v4.762c-.307 0-.556-.282-.556-.63v-3.244l-1.157 3.555h-.575l-1.124-3.565v3.305a.62.62 0 0 1-.15.41.481.481 0 0 1-.36.169v-4.762h.825zm-64.405.386c-.418 0-.744.175-.978.526-.235.35-.352.838-.352 1.463 0 .622.117 1.11.35 1.467.232.356.553.534.963.534.43 0 .761-.176.996-.526.234-.35.351-.846.351-1.485 0-.62-.117-1.105-.353-1.454a1.115 1.115 0 0 0-.977-.525zm18.854.502-.718 2.053h1.432l-.714-2.053zm36.617 0-.717 2.053h1.432l-.715-2.053zm20.036 0-.718 2.053h1.433l-.715-2.053zM.964 32.624H.59v1.738h.193c.748 0 1.123-.334 1.123-1.001 0-.491-.314-.737-.942-.737zM17.376.186v20.707c0 2.211 1.702 4.024 3.852 4.17 2.15-.146 3.852-1.959 3.852-4.17V14.81h5.427c2.28 0 4.13 1.872 4.13 4.178v6.082h4.43V12.977c0-2.306-1.85-4.179-4.13-4.179h-6.553V4.364c0-2.306 1.85-4.178 4.13-4.178h16.258v.928H35.819c-2.28 0-4.13 1.873-4.13 4.179V7.87h6.552c2.28 0 4.13 1.872 4.13 4.178V26H18.203c-2.28 0-4.13-1.872-4.13-4.179V.186h3.304zm45.703 0v.928H59.5c-2.279 0-4.13 1.873-4.13 4.179v6.871h3.58c2.28 0 4.13 1.873 4.13 4.179V26H49.592c-2.28 0-4.13-1.872-4.13-4.179V4.271h3.304v16.622c0 2.306 1.85 4.178 4.13 4.178h6.88v-7.8c0-2.306-1.851-4.178-4.131-4.178h-3.58V4.364c0-2.306 1.85-4.178 4.13-4.178h6.884zM97 .07v21.635c0 2.306-1.85 4.179-4.13 4.179H78.688v-.929h10.877c2.28 0 4.13-1.872 4.13-4.178V.07H97zM76.97 23.362v2.522H66.405v-2.522h10.563zM10.825 0v21.636c0 2.306-1.851 4.178-4.13 4.178H0v-.928h3.391c2.28 0 4.13-1.873 4.13-4.179V0h3.305zm17.558 15.913v5.908a4.19 4.19 0 0 1-1.536 3.25h4.485v-5.153a4.177 4.177 0 0 0-2.95-4.005zM69.71.186v15.948c0 2.306 1.85 4.178 4.13 4.178h3.13v.93h-6.434c-2.28 0-4.13-1.873-4.13-4.18V.186h3.304zM89.795.07v16.992c0 2.307-1.85 4.18-4.13 4.18h-6.977v-.93h3.672c2.28 0 4.13-1.872 4.13-4.178v-.604h-7.802V4.248c0-2.306 1.851-4.178 4.13-4.178h6.977zm-3.304.928h-.368c-2.28 0-4.13 1.873-4.13 4.179v9.425h4.498V.998z"
                  fill="#D5D5D5"
                  fill-rule="evenodd"
                />
              </svg>
              <svg width="129" height="16" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M126.338 2.334a8.606 8.606 0 0 1 2.657 5.925l.005.308V16H90v-.333l.001-.047v-.28l.001-.13v-.293c.005-1.353.011-3.782.018-6.186l.001-.554.005-1.888c.007-2.527 1.959-4.612 4.456-4.76L109.51.64l1.47-.088 9.044-.536a8.427 8.427 0 0 1 6.314 2.32zM48 5v11h-2V5h2zm27 0v11h-2V5h2zM43 0v16h-2V0h2zm40 5c1.575 0 2.8.508 3.684 1.501C87.55 7.475 88 8.823 88 10.556V16h-2.169v-5.444c0-1.118-.232-1.979-.734-2.572-.479-.566-1.182-.834-2.097-.834s-1.618.268-2.097.834c-.502.593-.734 1.454-.734 2.572V16H78v-5.444c0-1.732.445-3.08 1.306-4.054C80.183 5.51 81.41 5 83 5zM33.5 5c1.737 0 3.081.5 4.043 1.468.902.908 1.393 2.143 1.451 3.713L39 10.5v2.227c0 .242-.053.551-.166.927-.119.394-.381.778-.804 1.141-.386.332-.942.623-1.674.86-.7.227-1.651.345-2.856.345-1.205 0-2.157-.118-2.856-.345-.732-.237-1.288-.528-1.674-.86-.423-.363-.685-.747-.804-1.14-.113-.377-.166-.686-.166-.928 0-.84.141-1.498.403-1.98a2.765 2.765 0 0 1 1.112-1.14c.439-.24.956-.397 1.553-.465.414-.048.852-.078 1.313-.09l.47-.006h3.807c-.184-.543-.482-.977-.903-1.297-.556-.423-1.31-.621-2.255-.621-.871 0-1.593.18-2.16.556l-.166.118-.326.253-1.307-1.671.324-.256C30.811 5.382 32.021 5 33.5 5zm28.786-5v5.465a4.95 4.95 0 0 1 .96-.482c.665-.251 1.42-.38 2.264-.38.846 0 1.606.136 2.28.402.688.27 1.27.656 1.746 1.155.472.496.837 1.104 1.091 1.825.248.703.373 1.494.373 2.375V16h-2.286v-5.64c0-1.153-.261-2.042-.824-2.654-.547-.595-1.344-.875-2.38-.875-1.048 0-1.853.28-2.4.875-.562.612-.824 1.5-.824 2.654V16H60V0h2.286zm-7.661 5c1.458 0 2.662.362 3.616 1.068l.336.249L57.27 8.02l-.34-.254c-.58-.434-1.35-.639-2.305-.639-1.13 0-1.996.271-2.584.852-.589.58-.865 1.425-.865 2.52 0 1.106.275 1.953.863 2.528.589.575 1.455.844 2.586.844 1.098 0 1.954-.266 2.554-.83l.305-.288L59 14.296l-.302.287c-.5.475-1.098.832-1.799 1.07-.68.23-1.438.347-2.274.347-1.776 0-3.15-.496-4.134-1.458C49.507 13.58 49 12.237 49 10.5c0-1.723.506-3.064 1.49-4.032C51.474 5.5 52.849 5 54.625 5zM18.286 0v5.465c.293-.19.612-.351.96-.482.665-.251 1.42-.38 2.264-.38.846 0 1.606.136 2.28.402.688.27 1.27.656 1.745 1.155a5.023 5.023 0 0 1 1.092 1.825c.247.703.373 1.494.373 2.375V16h-2.286v-5.64c0-1.153-.262-2.042-.824-2.654-.547-.595-1.345-.875-2.38-.875-1.048 0-1.853.28-2.4.875-.562.612-.824 1.5-.824 2.654V16H16V0h2.286zM7.923 0C9.996 0 11.7.519 13.04 1.537l.35.266-1.35 1.818-.35-.265c-.967-.728-2.224-1.082-3.766-1.082-1.851 0-3.268.472-4.236 1.456-.97.985-1.435 2.412-1.435 4.27 0 1.87.466 3.305 1.435 4.29.968.984 2.385 1.456 4.236 1.456 1.587 0 2.864-.37 3.825-1.135V7.393L14 6.71v6.406c0 .287-.096.554-.298.8l-.016.02-.019.017C12.256 15.309 10.345 16 7.923 16c-1.235 0-2.337-.183-3.304-.543-.986-.367-1.821-.898-2.506-1.59-.686-.692-1.212-1.535-1.575-2.53C.18 10.36 0 9.247 0 8c0-1.234.18-2.342.538-3.326.363-1.003.89-1.849 1.575-2.541.685-.692 1.52-1.223 2.506-1.59C5.586.183 6.688 0 7.923 0zm28.949 11.174H33.5c-.814 0-1.467.021-1.96.064-.433.037-.767.107-.997.225a.581.581 0 0 0-.313.347c-.07.23-.102.535-.102.917 0 .164.067.3.195.414.186.166.432.297.732.4.334.116.711.199 1.132.25a10.732 10.732 0 0 0 2.626 0c.42-.051.798-.134 1.132-.25.3-.103.546-.234.732-.4a.548.548 0 0 0 .187-.319l.008-.095v-1.553zm76.19-6.884c-.707 0-1.339.105-1.893.311a3.918 3.918 0 0 0-1.44.914 3.958 3.958 0 0 0-.904 1.46c-.205.565-.309 1.2-.309 1.908 0 .716.104 1.354.309 1.914.208.573.51 1.057.904 1.455.394.397.873.702 1.44.913.554.207 1.186.312 1.894.312s1.34-.105 1.895-.312a3.918 3.918 0 0 0 1.439-.913c.394-.398.696-.882.905-1.455.204-.56.308-1.198.308-1.914 0-.707-.104-1.343-.308-1.907a3.958 3.958 0 0 0-.905-1.46 3.918 3.918 0 0 0-1.44-.915c-.554-.206-1.186-.311-1.894-.311zm-15.954 0c-1.03 0-1.83.234-2.4.681-.6.469-.904 1.119-.904 1.954 0 .493.105.893.302 1.204.195.309.45.558.764.747.297.178.636.319 1.018.42l.54.137.545.122.255.053c.328.07.608.141.842.212a2.7 2.7 0 0 1 .649.275c.13.081.224.176.277.29.06.126.086.282.086.468 0 .267-.054.483-.177.643-.13.17-.29.302-.48.396-.201.1-.417.164-.647.194a5.259 5.259 0 0 1-.67.049c-.2 0-.423-.017-.671-.049a2.031 2.031 0 0 1-.647-.194 1.318 1.318 0 0 1-.473-.393.936.936 0 0 1-.167-.491l-.006-.155v-.28h-1.34v.28l.006.205c.047.738.349 1.318.898 1.744.572.443 1.37.675 2.4.675 1.029 0 1.828-.232 2.403-.674.604-.465.91-1.114.91-1.95 0-.493-.104-.892-.302-1.2a2.298 2.298 0 0 0-.763-.74 3.922 3.922 0 0 0-1.019-.42l-.54-.136-.544-.122-.25-.053c-.322-.07-.598-.142-.83-.212a2.683 2.683 0 0 1-.648-.28.776.776 0 0 1-.292-.302 1.04 1.04 0 0 1-.089-.463c0-.268.053-.485.173-.645.127-.169.285-.3.473-.394.2-.1.417-.164.647-.194.248-.032.471-.048.67-.048.2 0 .422.016.67.048.231.03.447.095.647.194.19.095.35.227.48.396a.916.916 0 0 1 .171.49l.007.153v.28h1.34v-.28l-.007-.205c-.046-.738-.35-1.32-.903-1.75-.575-.446-1.375-.68-2.404-.68zm25.374.08h-3.614l-.104.007a.653.653 0 0 0-.363.183.635.635 0 0 0-.196.367l-.008.108v8.374h1.34V9.968h2.882l.227-.01c.299-.023.583-.094.853-.211a2.839 2.839 0 0 0 1.478-1.493c.145-.341.219-.705.219-1.091 0-.378-.07-.737-.213-1.077a2.748 2.748 0 0 0-.586-.888 2.832 2.832 0 0 0-.862-.595 2.7 2.7 0 0 0-1.053-.234zm-19.875 0h-1.34v9.04h1.34V9.152h3.948v4.256h1.34V4.37h-1.34V7.8h-3.948V4.37zm10.456 1.274c1.047 0 1.85.265 2.397.822.548.557.81 1.366.81 2.417 0 1.06-.262 1.872-.81 2.429-.548.557-1.35.823-2.397.823-1.047 0-1.849-.266-2.397-.823-.548-.557-.81-1.37-.81-2.429 0-1.051.262-1.86.81-2.417.548-.557 1.35-.822 2.397-.822zm9.356.067c.194 0 .378.038.552.114a1.458 1.458 0 0 1 .773 1.906 1.47 1.47 0 0 1-.773.781c-.13.057-.267.092-.408.106l-.144.007h-2.882V5.711h2.882zM75 0v3h-2V0h2zM48 0v3h-2V0h2z"
                  fill="#D5D5D5"
                  fill-rule="evenodd"
                />
              </svg>
              <svg width="126" height="16" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fill-rule="evenodd">
                  <path
                    d="M13.744 13.132V6.879l-2.211.666v5.093c-.943.746-2.197 1.107-3.755 1.107-1.817 0-3.208-.46-4.159-1.421-.951-.961-1.408-2.361-1.408-4.187 0-1.813.457-3.206 1.408-4.167.95-.96 2.342-1.421 4.16-1.421 1.513 0 2.747.345 3.695 1.056l.345.258 1.325-1.774-.343-.26C11.485.835 9.813.33 7.778.33c-1.213 0-2.294.178-3.244.53-.968.359-1.787.877-2.46 1.552S.884 3.913.528 4.891C.178 5.851 0 6.933 0 8.137c0 1.218.177 2.303.528 3.257.357.972.873 1.794 1.546 2.47.673.675 1.492 1.193 2.46 1.551.95.352 2.031.53 3.244.53 2.377 0 4.254-.674 5.64-1.997l.017-.017.016-.019c.199-.24.293-.5.293-.78zM21.143 4.588c-.816 0-1.546.128-2.19.378-.336.13-.645.29-.927.48V0h-2.212v15.945h2.211v-5.62c0-1.15.253-2.035.797-2.645.53-.593 1.308-.872 2.321-.872 1.002 0 1.774.28 2.302.872.544.61.797 1.495.797 2.645v5.62h2.211v-5.62c0-.878-.121-1.667-.36-2.367-.246-.72-.6-1.325-1.057-1.819a4.641 4.641 0 0 0-1.687-1.151c-.652-.265-1.387-.4-2.206-.4zM33.062 4.472c-1.537 0-2.794.399-3.777 1.177l-.336.267 1.357 1.742.339-.263c.613-.477 1.421-.703 2.417-.703.982 0 1.765.207 2.343.647.437.334.748.786.938 1.353h-3.956c-.66 0-1.278.034-1.852.1-.62.071-1.158.235-1.614.486-.482.265-.869.66-1.155 1.19-.272.501-.419 1.188-.419 2.064 0 .252.055.575.173.967.123.41.396.81.835 1.19.401.346.979.65 1.74.896.726.237 1.715.36 2.967.36s2.24-.123 2.968-.36c.76-.247 1.338-.55 1.739-.896.44-.38.712-.78.835-1.19.118-.392.173-.715.173-.967v-2.323c0-1.798-.515-3.196-1.514-4.206-1-1.01-2.396-1.531-4.201-1.531zm3.504 6.44v1.62a.56.56 0 0 1-.203.432c-.194.173-.449.31-.76.418-.348.12-.74.206-1.176.26a11.096 11.096 0 0 1-2.73 0 5.772 5.772 0 0 1-1.175-.26 2.219 2.219 0 0 1-.761-.418.56.56 0 0 1-.203-.432c0-.398.033-.718.106-.957a.606.606 0 0 1 .325-.362c.24-.123.586-.196 1.037-.235.511-.044 1.19-.066 2.036-.066h3.504zM40.79 15.945H43V0h-2.21zM45.591 15.945h2.212V4.782H45.59v11.163zm2.212-13.26V0H45.59v2.684h2.212zM58.954 14.468l.307-.3-1.54-1.609-.31.3c-.61.59-1.479.867-2.595.867-1.149 0-2.029-.28-2.627-.88-.597-.6-.876-1.484-.876-2.637 0-1.143.28-2.023.878-2.63.597-.604 1.477-.887 2.625-.887.97 0 1.753.214 2.342.666l.346.265 1.328-1.778-.342-.26c-.97-.736-2.192-1.113-3.674-1.113-1.805 0-3.201.52-4.2 1.531-1 1.01-1.514 2.408-1.514 4.206 0 1.811.515 3.213 1.514 4.216 1 1.003 2.396 1.52 4.2 1.52.85 0 1.62-.122 2.31-.362a4.863 4.863 0 0 0 1.828-1.115zM65.54 4.588c-.817 0-1.547.128-2.19.378-.337.13-.646.29-.928.48V0H60.21v15.945h2.211v-5.62c0-1.15.253-2.035.797-2.645.53-.593 1.308-.872 2.321-.872 1.002 0 1.773.28 2.302.872.544.61.797 1.495.797 2.645v5.62h2.211v-5.62c0-.878-.122-1.667-.36-2.367-.247-.72-.6-1.325-1.057-1.819a4.641 4.641 0 0 0-1.687-1.151c-.652-.265-1.387-.4-2.206-.4zM72.939 15.945h2.21V4.782h-2.21v11.163zm2.21-13.26V0h-2.21v2.684h2.21zM85.243 15.945h2.211v-5.62c0-1.79-.458-3.182-1.342-4.187-.901-1.025-2.15-1.55-3.756-1.55-1.62 0-2.872.526-3.766 1.551-.877 1.005-1.331 2.397-1.331 4.186v5.62h2.21v-5.62c0-1.155.238-2.043.749-2.655.488-.586 1.206-.862 2.138-.862.933 0 1.65.276 2.139.862.511.612.748 1.5.748 2.655v5.62zM126 6.62a6.47 6.47 0 0 0-2.03-4.71 6.42 6.42 0 0 0-4.81-1.737l-29.034 1.84L90.088 16H126V6.62z"
                    fill="#D5D5D5"
                  />
                  <path
                    d="M123.22 12.411V8.265l-1.574.474v3.317c-.596.46-1.385.681-2.36.681-1.155 0-2.04-.29-2.644-.9-.605-.61-.891-1.5-.891-2.66 0-1.153.287-2.04.891-2.65.604-.61 1.489-.9 2.644-.9.962 0 1.747.218 2.35.67l.28.21.944-1.262-.28-.211c-.862-.652-1.96-.986-3.294-.986-.795 0-1.504.117-2.126.348a4.412 4.412 0 0 0-1.62 1.021 4.424 4.424 0 0 0-1.017 1.632c-.23.63-.346 1.338-.346 2.127 0 .798.117 1.509.346 2.134.235.64.575 1.18 1.018 1.625.443.444.982.786 1.619 1.022.622.23 1.33.347 2.126.347 1.56 0 2.79-.445 3.7-1.313l.015-.014.013-.015a.843.843 0 0 0 .206-.551zM93.423 4.09a.761.761 0 0 0-.406.27.772.772 0 0 0-.149.478v9.39h1.574V7.666l2.764 4.594c.165.256.39.378.67.378a.794.794 0 0 0 .671-.378l2.777-4.598v6.568h1.574V4.838a.789.789 0 0 0-.57-.749.7.7 0 0 0-.512.016.774.774 0 0 0-.38.327l-3.559 5.896-3.548-5.897a.77.77 0 0 0-.39-.328.722.722 0 0 0-.516-.013zm17.902 7.606 1.262 2.533h1.74l-4.796-9.735c-.15-.302-.386-.446-.7-.446-.314 0-.55.144-.7.445l-4.77 9.736h1.768l1.212-2.533h4.984zm-.771-1.58h-3.446l1.723-3.496 1.723 3.496z"
                    fill="#FFF"
                  />
                </g>
              </svg>
            </>
          )}
        </div>
        <div style={{ width: isMobile ? "auto" : "50%", position: "relative" }}>
          <a
            referrerpolicy="origin"
            target="_blank"
            href="https://trustseal.enamad.ir/?id=156356&amp;Code=5UDVGaiUaXbzCtNYFHDL"
            style={{
              height: "60px",
              width: "50px",
              position: "absolute",
              left: globalState.themeDirection === "ltr" ? "" : 0,
              right: globalState.themeDirection === "ltr" ? 0 : "",
              bottom: 0,
              cursor: "pointer",
              border: "1px solid rgba(200,200,200,0.3)",
              borderRadius: "8px",
            }}
          >
            <img
              referrerpolicy="origin"
              src="https://Trustseal.eNamad.ir/logo.aspx?id=156356&amp;Code=5UDVGaiUaXbzCtNYFHDL"
              alt=""
              //style="cursor:pointer"
              id="5UDVGaiUaXbzCtNYFHDL"
              style={{ cursor: "pointer", width: "100%" }}
            />
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            referrerpolicy="origin"
            href="https://shop.ghalichin.com/ghalichin-govahi.png"
            style={{
              height: "60px",
              width: "70px",
              position: "absolute",
              left: globalState.themeDirection === "ltr" ? "" : 60,
              right: globalState.themeDirection === "ltr" ? 60 : "",
              bottom: 0,
              cursor: "pointer",
              border: "1px solid rgba(200,200,200,0.3)",
              borderRadius: "8px",
            }}
          >
            <img
              alt="endi"
              src="./static/img/anjooman-senfi.png"
              style={{ height: "100%", width: "100%" }}
            ></img>
          </a>
        </div>
      </div>

      <div className="footer-landing">
        <div
          style={{
            maxWidth: isMobile ? "100%" : 934,
            marginTop: isMobile ? 50 : 70,
            display: "flex",
            justifyContent: "space-between",
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          <div
            style={{
              margin: isMobile ? "0 19px" : "0 50px",
              fontSize: isMobile ? 8 : 12,
              lineHeight: "28px",
            }}
          >
            <span style={{ color: "#c3c6e1" }}> آدرس:</span>
            <span style={{ color: "#fff" }}>
              میدان ولیعصر - خیابان ولیعصر - کوچه نور بخش - ساختمان نوربخش -
              پلاک ۴ - رویای کمال
            </span>
          </div>

          <div
            style={{
              margin: isMobile ? "0 19px" : "0 0 0 50px",
              flex: 1,
              lineHeight: "28px",
            }}
            className="d-flex justify-content-between"
          >
            <p
              style={{
                fontSize: isMobile ? 8 : 12,
                width: "100%",
                marginLeft: globalState.themeDirection == "ltr" ? 0 : 20,
                marginRight: globalState.themeDirection == "ltr" ? 20 : 0,
              }}
            >
              <span style={{ color: "#c3c6e1" }}>تلفن:</span>
              <span style={{ color: "#fff", direction: "rtl" }}>
                ۸۸۸۰۹۰۰۰۶-۰۲۱
              </span>
            </p>
            <span
              onClick={() =>
                (window.location = "https://www.instagram.com/ghalichin.ir/")
              }
              className="headerInstagram"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={isMobile ? "16px" : "22"}
                height={isMobile ? "16px" : "22"}
                viewBox="0 0 22 21"
              >
                <g fill="none" fill-rule="evenodd">
                  <g fill="#FFF">
                    <g>
                      <path
                        d="M14.543 0H6.17C2.768 0 0 2.768 0 6.17v8.372c0 3.403 2.768 6.171 6.17 6.171h8.372c3.403 0 6.171-2.768 6.171-6.17V6.17c0-3.403-2.768-6.171-6.17-6.171zm4.086 14.543c0 2.256-1.83 4.086-4.087 4.086H6.171c-2.258 0-4.087-1.83-4.087-4.087V6.171c0-2.258 1.83-4.087 4.087-4.087h8.372c2.257 0 4.086 1.83 4.086 4.087v8.372z"
                        transform="translate(-307 -60) translate(307.161 60)"
                      />
                      <path
                        d="M10.357 5c-2.954 0-5.358 2.403-5.358 5.356 0 2.954 2.404 5.358 5.358 5.358 2.954 0 5.357-2.404 5.357-5.358C15.714 7.402 13.31 5 10.357 5zm0 8.63c-1.808 0-3.274-1.466-3.274-3.274 0-1.807 1.466-3.273 3.274-3.273 1.807 0 3.273 1.466 3.273 3.274 0 1.807-1.466 3.273-3.274 3.273zM15.724 3.756c.709 0 1.284.575 1.284 1.284 0 .708-.575 1.283-1.284 1.283-.709 0-1.284-.575-1.284-1.283 0-.709.575-1.284 1.284-1.284z"
                        transform="translate(-307 -60) translate(307.161 60)"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </span>

            <span
              style={{
                display: "flex",
                alignItems: "center",
              }}
              onClick={() =>
                (window.location = "https://twitter.com/ghalichin?s=08")
              }
              className="headerInstagram"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={isMobile ? "16px" : "22"}
                height={isMobile ? "16px" : "22"}
                viewBox="0 0 22 19"
                style={{
                  margin:
                    globalState.themeDirection == "rtr"
                      ? isMobile
                        ? "0 0 0 9px"
                        : "0 0 0 20px"
                      : isMobile
                        ? "0 9px  0 0"
                        : "0 20px  0 0",
                }}
              >
                <g fill="none" fill-rule="evenodd">
                  <g fill="#FFF">
                    <path
                      d="M280.742 63.63c-.468.207-.954.371-1.453.49.55-.523.963-1.176 1.196-1.905.067-.208-.16-.388-.348-.277-.694.412-1.441.72-2.221.918-.046.011-.092.017-.14.017-.141 0-.28-.052-.388-.148-.83-.732-1.898-1.135-3.007-1.135-.48 0-.964.075-1.44.222-1.473.457-2.61 1.673-2.966 3.172-.134.563-.17 1.126-.108 1.673.007.063-.023.107-.041.128-.032.036-.078.057-.126.057l-.016-.001c-3.225-.3-6.133-1.853-8.19-4.375-.104-.129-.305-.113-.389.03-.402.69-.615 1.48-.615 2.285 0 1.231.495 2.392 1.355 3.239-.362-.086-.712-.22-1.037-.401-.157-.088-.35.025-.353.204-.022 1.83 1.05 3.459 2.654 4.192l-.097.001c-.254 0-.512-.024-.765-.073-.177-.034-.326.134-.271.306.52 1.627 1.921 2.826 3.597 3.098-1.39.933-3.01 1.426-4.696 1.426h-.526c-.162 0-.299.105-.34.262-.04.154.034.317.172.398 1.9 1.105 4.067 1.69 6.267 1.69 1.927 0 3.729-.383 5.356-1.137 1.492-.69 2.81-1.679 3.919-2.936 1.032-1.171 1.84-2.523 2.4-4.019.533-1.425.815-2.946.815-4.398v-.07c0-.232.105-.452.29-.601.697-.567 1.305-1.234 1.806-1.983.132-.198-.076-.446-.294-.35z"
                      transform="translate(-260 -61)"
                    />
                  </g>
                </g>
              </svg>
            </span>
          </div>
        </div>
        <span
          style={{
            position: "absolute",
            bottom: 5,
            color: "#fff",
            opacity: 0.25,
            fontSize: 10,
            fontFamily: "sans-serif",
            direction: "ltr",
          }}
        >
          © 2020 - All Right Reserved By Ghalichin.com
        </span>
      </div>
    </div>
  );
};

export default Landing;
